export default {
  // the app loader on the first load (#223)
  app_loader: {
    title: 'GreenMapper wird vorbereitet',
    steps: {
      connect: 'Verbindung zu GreenMapper',
      account: 'Dein Konto wird geladen',
      places: 'Gebiete auf die Karte setzen',
      communities: 'Communities werden geladen',
      news: 'Neuigkeiten und Einstellungen',
      settings: 'Alles wird vorbereitet',
      ready: 'Fertig!'
    },
    slow: 'Das dauert länger als sonst.',
    retry: 'Erneut versuchen',
    open_anyway: 'Trotzdem öffnen'
  },
  // a login link from an e-mail and an unknown address (#340: on the app loader's card)
  redirect: {
    failed: 'Dieser Anmeldelink funktioniert nicht mehr',
    title: 'Wir melden Sie an…',
    step: 'Anmelden'
  },
  not_found: {
    checking: 'Wir prüfen, ob die Seite existiert…',
    checking_sub: 'Die Seite suchen',
    title: '404: Seite nicht gefunden',
    text: 'Unter dieser Adresse gibt es nichts.',
    home: 'Zurück zur Startseite'
  },
  notice: {
    progress: '{done} von {total} Orten markiert',
    places_left: 'Noch 1 Ort zu markieren | Noch {left} Orte zu markieren',
    participation_hint: 'Nur noch wenige Schritte, um deine Orte abzuschließen.',
    participation_unfinished: 'Deine Teilnahme ist noch nicht abgeschlossen'
  },
  home_tiles: {
    areas_count: '{count} Gebiet | {count} Gebiete',
    communities_count: '{count} Community | {count} Communities',
    budget_line: '{amount} Budget · {pct}% zugesagt',
    subscribers: '{count} Abonnent | {count} Abonnenten',
    notifications: 'Benachrichtigungen',
    unread: '{count} ungelesen',
    all_read: 'Alles gelesen',
    no_messages: 'Noch keine Nachrichten',
    pledged: 'zugesagt',
    no_budget: 'Noch kein Naturbudget',
    no_areas: 'Noch keine Gebiete. Markiere Orte, die dir wichtig sind, auf der Karte.',
    no_communities: 'Du folgst noch keiner Community.',
    browse_map: 'Karte ansehen',
    greet_morning: 'Guten Morgen, {name}',
    greet_afternoon: 'Guten Tag, {name}',
    greet_evening: 'Guten Abend, {name}',
    per_year: 'pro Jahr',
    new: 'neu'
  },
  // the create-community wizard's texts (#126)
  wizard_versions: {
    // #321: the find screen's list / map switch (phones) and the larger map (wider screens)
    search_short: 'Suchen',
    view_list: 'Liste',
    view_map: 'Karte',
    map_larger: 'Größere Karte',
    map_smaller: 'Liste wieder zeigen',
    cancel: 'Abbrechen',
    question: 'Welches Gebiet betreust du?',
    results: 'Ergebnisse',
    legend: 'Filter',
    filters_open: 'Filter öffnen',
    filters_collapse: 'Filter einklappen',
    new_community: 'Neue Community',
    back_to_results: 'Zurück zur Liste',
    col_name: 'Name',
    my_location: 'Mein Standort',
    locate: 'Gebiete bei meinem Standort',
    locate_failed: 'Dein Standort konnte nicht bestimmt werden. Suche nach einem Ort.',
    locate_denied: 'Du hast deinen Standort nicht freigegeben. Erlaube ihn im Browser oder suche nach einem Ort.',
    locate_insecure: 'Dein Standort funktioniert nur über eine sichere Verbindung (https). Suche nach einem Ort.',
    loading_results: 'Gebiete laden…',
    lists_n: '{count} Listen',
    col_type: 'Art',
    col_country: 'Land',
    col_size: 'Fläche',
    position: 'Lage',
    loading_title: 'Die Karte wird vorbereitet',
    load_lists: 'Die Listen',
    load_areas: 'Die ersten Gebiete',
    load_map: '{list} auf der Karte',
    load_index: 'Die Karte aufbauen',
    areas_here: '{count} Gebiete hier',
    choose_area_here: 'Wähle eines der {count} Gebiete hier',
    map_updating: 'Karte wird aktualisiert…',
    map_areas_loading: 'Gebiete werden geladen…',
    map_loading: 'Die Karte lädt noch alle Gebiete…',
    sheet: 'Liste größer oder kleiner',
    count_areas: 'keine Gebiete | 1 Gebiet | {count} Gebiete',
    // waits (the user, 11 Oct): a long one, no connection, a failure; "Try again" asks the same again
    slow: 'Das dauert länger als sonst.',
    try_again: 'Erneut versuchen',
    offline: 'Keine Verbindung zum Server. Verbinde neu…',
    reconnect: 'Jetzt versuchen',
    lists_failed: 'Die Listen konnten nicht geladen werden.',
    places_failed: 'Die Ortssuche ist fehlgeschlagen.',
    sending: 'Deine Community wird eingereicht…',
    count_failed: 'Die Fans konnten nicht gezählt werden.'
  },
  messages: {
    pictures_missing: 'Ein Bild dieser Diskussion konnte nicht geladen werden: es fällt beim Speichern weg.',
    // account_created: 'Please check your email to verify your registration. This sometimes can take up to 10 minutes. Please check the spam folder if the email has not been received.',
    // password_forgot: 'Please check your email to reset your password.',
    // verification_success: 'Your e-mail has been verified. You can now login.',
    // verification_failed: 'Verification has failed.',
    // password_recover_success: 'Your password has been reset. You can now login with the new password.',
    // logout_confirmation: 'Are you sure you want to log out?',
    // confirm: 'Confirm',
    // update_available: 'A new update is available. Click on ok to reload the page.',
    // account_signed_out: 'You have been signed out',
    // account_updated: 'Account succesfully updated'
    account_created: 'Account erstellt',
    password_forgot: 'Bitte schauen Sie in Ihre E-Mail um Ihr Passwort zurück zusetzen',
    account_signed_out: 'Sie wurden ausgeloggt',
    logout_failed: 'Das Abmelden ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
    account_updated: 'Account aktualisiert',
    verification_success: 'Ihre E-Mail ist verifiziert. Sie können sich nun einloggen.',
    verification_failed: 'Verifikation missglückt',
    password_recover_success: 'Ihr Passwort wurde zurückgesetzt. Sie können sich nun mit dem neuen Passwort anmelden.',
    password_reset_link_invalid: 'Dieser Link funktioniert nicht mehr. Ein Link zum Zurücksetzen des Passworts funktioniert einmal und 24 Stunden lang. Fordern Sie auf dem Anmeldebildschirm mit \'Passwort vergessen?\' einen neuen an.',
    password_reset_failed: 'Ihr Passwort konnte nicht geändert werden. Bitte versuchen Sie es erneut.',
    password_reset_to_login: 'Zum Anmeldebildschirm',
    logout_confirmation: 'Sind Sie sicher, dass Sie sich ausloggen wollen?',
    login_confirmation: 'Sie haben sich erfolgreich wieder eingeloggt. Willkommen zurück!',
    login_failed: 'E-Mail- und Passwortkombination nicht erkannt',
    confirm: 'Bestätigen',
    update_available: 'Ein neues Update ist verfügbar. Klicken Sie auf OK um die Seite neu zu laden.',
    update_ready: 'Eine neue Version der App ist bereit.',
    update_reload: 'Neu laden',
    url_copied_to_clipboard: 'Der Karten-URL wurde in die Zwischenablage kopiert.',
    add_area_account_required: 'Um ein neues Gebiet hinzuzufügen, brauchen Sie einen Account.',
    area_deleted: 'Gebiet wurde gelöscht.',
    area_updated: 'Gebiet wurde aktualisiert',
    unsubscribed: 'Sie haben sich von der Community abgemeldet.',
    subscribed: 'Sie sind nun Teil dieser Community',
    thread_created: 'Eine neue Diskussion wurde erstellt.',
    thread_updated: 'Die Diskussion wurde aktualisiert',
    comment_created: 'Sie haben eine Antwort gepostet',
    comment_reported: 'Das Bild wurde an die Moderation gemeldet',
    comment_unreported: 'Dieser Inhalt wurde von dem/der Moderator*in gelöscht.',
    comment_deleted: 'Dieser Inhalt wurde gelöscht.',
    community_updated: 'Diese Community wurde aktualisiert.',
    RMS_send: 'Moderator*in-anfrage gesendet',
    poll_created: 'Umfrage erstellt',
    polis_created: 'Polis erstellt',
    meeting_created: 'Treffen erstellt',
    meeting_invite_accepted: 'Sie haben die Einladung angenommen.',
    meeting_invite_declined: 'Sie haben die Einladung abgelehnt.',
    pledge_funding_completed: 'Virtueller Finanzierungsbetrag erfolgreich abgeschlossen.',
    pledge_added: 'Danke für Ihren Beitrag von € ',
    pledge_rejected: 'Danke für Ihre Erläuterung',
    pledge_created: 'Zusage erstellt',
    pledge_updated: 'Zusage aktualisiert',
    pledge_deleted: 'Die Zusage wurde gelöscht',
    pledge_pictures_missing: 'Ein Foto dieser Zusage konnte nicht geladen werden: Es entfällt beim Speichern.',
    treasure_created: 'Schatz hinzugefügt'
  },
  errors: {
    general_error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    not_found: 'Entschuldigung, hier ist leider nichts...',
    network: 'Netzwerkfehler. Bitte überprüfen Sie Ihre Internetverbindung.',
    // fields: 'Please correct the input fields',
    required: 'Pflichtfeld',
    register: {
      password_length: 'Das Passwort muss mindestens {length} Zeichen lang sein.',
      password_match: 'Passwörter stimmen nicht überein.',
      email_valid: 'Bitte benutzen Sie eine gültige E-Mail Adresse.',
      name_length: ' Benutzer*innenname muss zwischen {minLength} und {maxLength} Zeichen lang sein.',
      organization_length: 'Name der Organisation muss zwischen {minLength} und {maxLength} Zeichen lang sein.'
    }
  },
  buttons: {
    fullscreen: 'Vollbild',
    fullscreen_exit: 'Vollbild beenden',
    pledge: 'Mittel zusagen',
    ok: 'Ok',
    submit: 'Übermitteln',
    logout: 'Ausloggen',
    cancel: 'Abbrechen',
    login: 'Einloggen',
    register: 'Übermitteln',
    // Finn's Comment: I don't quite know where submit is used...
    // go_back: 'Zurück',
    send: 'Senden',
    reSend: 'Erneut senden',
    close: 'Schließen',
    previous: 'Zurück',
    save: 'Speichern',
    create: 'Erstellen',
    update: 'Aktualisieren',
    delete: 'Löschen',
    subscribe: 'Abonnieren',
    unsubscribe: 'Abbestellen',
    next: 'Weiter',
    continue: 'Weiter',
    back: 'Zurück',
    add: 'Hinzufügen',
    edit: 'Bearbeiten',
    reply: 'Antworten',
    report: 'Melden',
    unreport: 'Melden zurückziehen',
    goto_authenticate: 'Zum Log-in',
    stop: 'Stop',
    pauze: 'Pause',
    continue_register: 'Registrierung fortführen',
    continue_participation: 'Beteiligung fortführen',
    mark_places: 'Orte markieren',
    become_moderator: 'Moderator*in werden',
    add_image: 'Bild hinzufügen',
    accept: 'Annehmen',
    decline: 'Ablehnen',
    reset: 'Zurücksetzen',
    discard: 'Verwerfen'
  },
  headers: {
    area_owners: 'Gebietseigentümer',
    admin_home: 'Home',
    fans: 'Fans',
    maintenance: 'Wartung',
    login: 'Einloggen',
    register: 'Registrieren',
    password_forgot: 'Neues Passwort anfragen',
    password_recover: 'Passwort zurücksetzen',
    administrator: 'Administrator*in',
    navigation: 'Navigation',
    my_overview: 'Meine Übersicht',
    overview: 'Übersicht',
    users: 'Benutzer',
    communities: 'Communities'
  },
  activities: {
    act_cycl: {
      title: 'Fahrrad fahren'
    },
    act_walk: {
      title: 'Wandern oder Joggen'
    },
    act_tour: {
      title: 'Mit dem Auto oder Motorrad herumfahren'
    },
    act_natu: {
      title: 'Natur beobachten'
    },
    act_water: {
      title: 'Wassersport'
    },
    act_play: {
      title: 'Spielen oder Sitzen'
    },
    act_wintr: {
      title: 'Wintersport'
    },
    act_mount: {
      title: 'Bergsteigen'
    }
  },
  labels: {
    upvote: 'Zustimmen',
    // a post's reply started from a comment (#340): the bar above the reply
    replying_to: 'Antwort an',
    replying_to_cancel: 'Nicht als Antwort an {name}',
    // the photo picker (UiPhotoPicker, #469)
    photo_add: 'Foto hinzufügen',
    photos_add: 'Fotos hinzufügen',
    photos_add_short: 'Hinzufügen',
    photos_drop: 'tippen oder hierher ziehen (.jpg)',
    photos_jpg_only: 'Nur .jpg-Fotos können hinzugefügt werden.',
    downvote: 'Nicht zustimmen',
    // a wizard's step (UiWizard, #355)
    step_of: 'Schritt {step} von {total}',
    rows_of: '{shown} von {total}',
    show_more: '{n} weitere zeigen',
    account_required: 'Account erforderlich',
    read_more: 'Mehr lesen',
    'area_create_button': 'Speichern',
    'area_update_button': 'Speichern',
    'area_created_succes': 'Gebiet erfolgreich hinzugefügt',
    'area_updated_succes': 'Gebiet erfolgreich aktualisiert',
    'community_created_succes': 'Community wurde erfolgreich erstellt',
    agree_disclaimer: 'Ich stimme den Geschäftsbedingungen zu.',
    my_account: 'Mein Account',
    register: 'Account erstellen',
    logout: 'Ausloggen',
    login: 'Einloggen',
    email: 'E-Mail Adresse',
    name: 'Benutzer*innenname',
    companyName: 'Firmenname',
    organization: 'Name der Organisation',
    sector: 'Sektor',
    address: 'Addresse',
    address_search: 'Wohnort',
    // zipcodeCompany: 'Zipcode headquarter',
    website: 'Webseite',
    city: 'Stadt',
    // cityCompany: 'City headquarter',
    age: 'Altersgruppe',
    education: 'Bildungsgrad',
    gender: 'Geschlecht',
    type: 'Typ',
    password: 'Passwort',
    repeat_password: 'Passwort wiederholen',
    remember_me: 'Angemeldet bleiben',
    show_password: 'Passwort anzeigen',
    hide_password: 'Passwort verbergen',
    clear_address: 'Andere Adresse wählen',
    password_forgot: 'Haben Sie ihr Passwort vergessen?',
    home: 'Zuhause',
    here: 'Hier',
    // Finn's Comment: Don't quite know where that goes...
    neighbourhood: 'Nachbarschaft',
    'living-area': 'Region',
    country: 'Land',
    worldwide: 'Weltweit',
    share_this_area: 'Dieses Gebiet teilen',
    share_this_community: 'Diese Community teilen',
    subscribed: 'Aboniert',
    reply: 'Antworten',
    comment: 'Kommentieren',
    finish: 'Abschließen',
    readmore: 'Mehr lesen',
    search: 'Suchen',
    created_on: 'Erstellt am',
    dear: 'Am besten',
    karma: 'Schicksal'
  },
  pages: {
    free_draw: {
      title: 'Zeichne dein Gebiet',
      tools: 'Zeichenwerkzeuge',
      mode_edit: 'Punkte bearbeiten',
      mode_move: 'Form verschieben',
      mode_rotate: 'Form drehen',
      undo: 'Rückgängig',
      more_tools: 'Weitere Werkzeuge',
      redo: 'Wiederholen',
      delete_points: 'Punkte löschen',
      import: 'Datei importieren (GeoJSON oder KML)',
      start_over: 'Neu beginnen',
      start_over_title: 'Neu beginnen?',
      start_over_text: 'Das entfernt die Form. Du kannst es noch rückgängig machen.',
      layer_map: 'Karte',
      layer_satellite: 'Satellit',
      my_location: 'Mein Standort',
      zoom_to_shape: 'Auf Form zoomen',
      search_place: 'Ort suchen',
      search_place_placeholder: 'Ort, dann Enter',
      warn_point_outside: 'Deine Zeichnung enthält den Standort von {name} nicht.',
      warn_size: 'Deine Zeichnung ({drawn}) weicht stark von der angegebenen Größe ab ({reported}).',
      warn_huge: 'Dein Gebiet ist sehr groß: {size}. Stimmt das?',
      more: 'Mehr',
      hint_closed_phone: 'Form geschlossen. Ziehe einen Punkt, um die Grenze anzupassen; halte einen Punkt, um ihn zu entfernen.',
      hint_many_phone: 'Form mit {count} Punkten: sie werden verteilt gezeigt. Zoome hinein für mehr Punkte zum Ziehen.',
      legend_title: 'Auch nützlich',
      legend_last: 'Klicke auf den letzten Punkt, um ihn zu entfernen',
      legend_undo: 'Strg+Z macht rückgängig, Strg+Y stellt wieder her',
      legend_import: 'Eine Grenze importieren geht auch (GeoJSON oder KML)',
      reported: 'Angegeben: {size}',
      your_drawing: 'deine Zeichnung: {size}',
      area: 'Fläche',
      border: 'Grenze',
      close_shape: 'Form schließen',
      close_shape_tip: 'Oder auf den ersten Punkt klicken oder Esc drücken',
      points_count: 'keine Punkte | 1 Punkt | {count} Punkte',
      hint_tap: 'Klicke auf die Karte, um Punkte entlang der Grenze zu setzen. Klicke auf den ersten Punkt, um die Form zu schließen.',
      hint_edit: 'Ziehe einen Punkt, um ihn zu verschieben. Ziehe einen kleinen Punkt auf einer Linie, um einen Punkt hinzuzufügen. Rechtsklick auf einen Punkt entfernt ihn.',
      hint_edit_many: 'Diese Form hat viele Punkte: sie werden verteilt gezeigt, mehr je weiter du hineinzoomst. Ziehe einen Punkt, um ihn zu verschieben. Ziehe einen kleinen Punkt auf einer Linie, um einen Punkt hinzuzufügen. Rechtsklick auf einen Punkt entfernt ihn.',
      hint_delete: 'Tippe auf einen Punkt, um ihn zu entfernen. Tippe erneut auf das Löschwerkzeug, um aufzuhören.',
      hint_delete_click: 'Klicke auf einen Punkt, um ihn zu entfernen. Klicke erneut auf das Löschwerkzeug, um aufzuhören.',
      hint_move: 'Ziehe die Form, um sie zu verschieben.',
      hint_rotate: 'Ziehe an einem Eckpunkt, um die Form zu drehen.',
      check_points: 'Geschlossene Form mit mindestens {min} Punkten',
      check_crossing: 'Keine sich kreuzenden Linien',
      check_range: 'Nicht über die Datumsgrenze (180°)',
      check_area_min: 'Mindestens {minArea}',
      check_area_max: 'Höchstens {maxArea}',
      check_points_max: 'Höchstens {max} Punkte',
      problem_points: 'Schließe die Form mit mindestens {min} Punkten.',
      problem_crossing: 'Linien kreuzen sich. Verschiebe einen Punkt, bis sie sich nicht mehr kreuzen.',
      problem_range: 'Die Form überquert die Datumsgrenze (180°). Zeichne sie auf einer Seite dieser Linie.',
      problem_area_min: 'Das Gebiet ist zu klein: mindestens {minArea}.',
      problem_area_max: 'Das Gebiet ist zu groß: höchstens {maxArea}.',
      problem_points_max: 'Die Form hat zu viele Punkte: höchstens {max}.',
      rejected_cross: 'Linien dürfen sich nicht kreuzen',
      rejected_min_points: 'Mindestens {min} Punkte',
      location_unavailable: 'Dein Standort ist nicht verfügbar.',
      imported: 'Form mit {count} Punkten importiert. Prüfe sie und passe sie bei Bedarf an.',
      import_errors: {
        unknown_format: 'Diese Datei ist kein GeoJSON oder KML.',
        no_polygon: 'Die Datei enthält kein Gebiet (Polygon).',
        multiple: 'Die Datei enthält mehr als ein Gebiet. Verwende eine Datei mit einem Gebiet.',
        holes: 'Das Gebiet hat Löcher. Verwende ein Gebiet ohne Löcher.',
        invalid: 'Das Gebiet in dieser Datei ist nicht gültig.'
      }
    },
    owner_community_new: {
      // #197: the boundary lies on (almost) the same area as an existing community
      overlap: {
        warning: 'Es gibt schon eine Community auf (fast) demselben Gebiet: {title}. Du kannst trotzdem eine erstellen.',
        // another owner's community before its first approval: its name is not shown (#96)
        unnamed: 'eine Community, die auf Freigabe wartet'
      },
      // #198: after drawing, the list area the drawing matches
      suggest: {
        title_used: 'Dein Gebiet',
        locked_size: 'Offizielle Grenze · {size}',
        locked_hint: 'Du verwendest die offizielle Grenze. Selbst zeichnen? Wähle Rückgängig.',
        checking: 'Wird geprüft…',
        choose_first: 'Wähle zuerst: die offizielle Grenze oder deine eigene Zeichnung',
        question: 'Meinst du dieses Gebiet?',
        previous: 'Zurück',
        next: 'Weiter',
        count: '{at} von {of}',
        use_official: 'Offizielle Grenze verwenden',
        link: 'Meine Zeichnung verknüpfen',
        keep: 'Meine Zeichnung behalten',
        link_note: 'Dieses Gebiet hat keine Grenze in der Liste: deine Zeichnung wird seine Grenze, Name und Angaben kommen aus der Liste. Andere Eigentümer können es danach nicht mehr wählen.',
        used: 'Offizielle Grenze von {name} verwendet',
        linked: 'Deine Zeichnung ist mit {name} verknüpft',
        kept: 'Du behältst deine eigene Zeichnung',
        undo: 'Rückgängig',
        show_again: 'Doch ansehen'
      },
      title_draw: 'Zeichne dein Gebiet',
      title_draw_boundary: 'Grenze zeichnen',
      title_details: 'Gib deiner Community einen Namen',
      title_fans: 'Wer als Fan zählt',
      title_fans_named: 'Wer wird Fan von {name}?',
      drawn_tag: 'Selbst gezeichnet',
      continue_short: 'Weiter',
      continue: 'Weiter zu Name und Beschreibung',
      continue_fans: 'Weiter zu: Wer als Fan zählt',
      name: 'Name der Community',
      name_required: 'Gib deiner Community einen Namen.',
      description: 'Beschreibung',
      description_hint: 'Was ist das für ein Gebiet und worum geht es in der Community?',
      description_required: 'Beschreibe das Gebiet und die Community.',
      submitted: '{name} ist zur Prüfung eingereicht',
      // the last step: the community as its page will show it (#96)
      review: {
        fans_count: '{n} Fan | {n} Fans',
        fans_few: 'weniger als {n} Fans',
        more: 'mehr',
        submit: 'Zur Prüfung einreichen',
        confirm_title: 'Community einreichen?',
        confirm_text: 'Greenmapper prüft {name} zuerst. Nach der Freigabe bekommt deine Community {fans}. Name und Beschreibung kannst du danach noch ändern.',
        confirm_plain: 'Greenmapper prüft deine Community zuerst. Name und Beschreibung kannst du danach noch ändern.',
        confirm_back: 'Noch einmal ansehen',
        confirm_submit: 'Einreichen'
      },
      steps: {
        area: 'Gebiet',
        fans: 'Fans',
        name: 'Name'
      },
      exit: 'Beenden',
      exit_title: 'Das Erstellen dieser Community beenden?',
      exit_text: 'Was du gewählt, gezeichnet oder eingegeben hast, wird nicht gespeichert.',
      exit_keep: 'Weitermachen',
      exit_confirm: 'Beenden',
      back: 'Zurück',
      method: {
        free_title: 'Selbst zeichnen',
        free_text: 'Zeichne die Grenze deines Gebiets auf der Karte oder importiere eine GeoJSON- oder KML-Datei.'
      },
      find: {
        clear_filters: 'Filter entfernen',
        without_list: 'Ohne {list}',
        with_list: 'Mit {list}',
        filters: 'Filter',
        clear_all: 'Alle entfernen',
        close: 'Schließen',
        lists_title: 'Listen',
        size: 'Fläche',
        size_any: 'Alle Größen',
        size_up_to: 'Bis {max} ha',
        size_from: 'Ab {min} ha',
        size_between: '{min}–{max} ha',
        place_title: 'Ort',
        clear_place: 'Ort entfernen',
        place_remove: 'Entfernen',
        countries_all: 'Alle {count} Länder zeigen',
        countries_less: 'Weniger Länder',
        show_n: '1 Gebiet zeigen | {count} Gebiete zeigen',
        places_none_in: 'Kein Ort „{query}“ in {country}',
        around_chip: 'Um {place}',
        none_near_named: 'Kein Gebiet mit „{query}“ bei {place}.',
        radius: 'Umkreis',
        radius_caption: 'Im Umkreis von',
        other_places: 'Andere Orte mit diesem Namen',
        near_action: 'Gebiete in der Nähe',
        show_all: 'Das Gebiet mit „{query}“ zeigen | Alle {count} Gebiete mit „{query}“ zeigen',
        country_search: 'Land suchen',
        country_any: 'Alle Länder',
        country_none: 'Kein Land gefunden',
        none_named: 'Kein Gebiet namens „{query}“',
        show_all_more: 'Alle Gebiete mit „{query}“ zeigen ({count}+)',
        places_none: 'Kein Ort gefunden',
        places_searching: 'Orte werden gesucht…',
        places_failed: 'Die Ortssuche funktioniert gerade nicht',
        availability: 'Verfügbarkeit',
        count_more_short: '{count}+',
        refine: 'Verfeinere deine Suche, um den Rest zu sehen.',
        near_title: 'Gebiete um {place} (bis {km} km)',
        places_group: 'Orte',
        areas_group: 'Gebiete',
        place_kinds: {
          city: 'Stadt',
          town: 'Ort',
          village: 'Dorf',
          hamlet: 'Weiler',
          suburb: 'Stadtteil',
          municipality: 'Gemeinde',
          county: 'Kreis',
          state: 'Bundesland',
          country: 'Land',
          island: 'Insel',
          nature_reserve: 'Naturschutzgebiet',
          national_park: 'Nationalpark',
          protected_area: 'Schutzgebiet',
          lake: 'See',
          peak: 'Gipfel',
          forest: 'Wald',
          wood: 'Wald',
          heath: 'Heide',
          moor: 'Moor',
          wetland: 'Feuchtgebiet'
        },
        title: 'Finde dein Gebiet',
        search: 'Gebiet oder Ort suchen',
        country: 'Land',
        all: 'Alle',
        available: 'Frei',
        taken: 'Vergeben',
        count: 'keine Gebiete | 1 Gebiet | {count} Gebiete',
        failed: 'Die Suche ist fehlgeschlagen.',
        place_failed: 'Die Ortssuche antwortet gerade nicht. Die Suche nach Namen funktioniert weiterhin.',
        no_places: 'Kein Ort gefunden für „{query}“.',
        none_near: 'Keine gelisteten Gebiete bei {place}.',
        none_filters: 'Keine Gebiete mit diesen Filtern.',
        none_taken: 'Keine vergebenen Gebiete.',
        badge_official: 'Offiziell',
        badge_partial: 'Kernzone',
        badge_proxy: 'Angenähert',
        badge_draw: 'Selbst zeichnen',
        // #196: the other lists the same area is in (one row per area group)
        also_in: 'Auch in {lists}',
        badge_in_use: 'Vergeben',
        badge_disabled: 'Nicht verfügbar',
        sources_short: {
          unesco: 'UNESCO',
          eea: 'EUA',
          wdpa: 'WDPA',
          osm: 'OSM',
          research: 'Forschung',
          national: 'National',
          arcgis: 'Kartenebene',
          province: 'Provinz',
          other: 'Andere Quelle'
        },
        osm_credit: '© OpenStreetMap contributors'
      },
      // who counts as a fan (#96)
      fans: {
        what: 'Wer auf Greenmapper einen Ort in deiner Fanzone markiert hat, wird Fan und bekommt deine Nachrichten.',
        what_close: 'Erklärung schließen',
        what_open: 'Was ist ein Fan?',
        slider: 'Größe der Fanzone',
        area_only: 'Nur dein Gebiet',
        area_only_short: 'Nur Gebiet',
        recommended: 'Empfohlen',
        wide: 'Weit',
        back_to_recommended: 'Zurück zu empfohlen',
        fans_short: 'Fans in der Zone',
        legend_area: 'Dein Gebiet',
        legend_zone: 'Fanzone',
        // what each line on the map is for: the same words under the legend on every step and screen width
        legend_area_explain: 'Als Community gezeigt',
        legend_zone_explain: 'Bestimmt, wer Fan wird',
        legend_start: 'Empfohlen',
        zone_is_area: 'gleich deinem Gebiet',
        load_failed: 'Die Fanzone konnte nicht geladen werden.',
        retry: 'Erneut versuchen',
        failed: 'Diese Stellung konnte nicht berechnet werden. Wähle eine andere Stellung.',
        invalid: 'Die Fanzone wurde nicht akzeptiert. Wähle eine andere Stellung und versuche es erneut.'
      },
      official: {
        not_listed_title: 'Ist dein Gebiet nicht dabei?',
        not_listed_text: 'Dann zeichne seine Grenze selbst auf der Karte.',
        choose_this: 'Dieses Gebiet wählen',
        title: 'Dein Gebiet',
        retry: 'Erneut versuchen',
        no_results: 'Kein Gebiet gefunden für „{query}“.',
        badge_official: 'Offizielle Grenze',
        badge_partial: 'Nur Kernzone',
        badge_proxy: 'Angenähertes Gebiet',
        badge_draw: 'Keine Grenze: du zeichnest sie',
        reason_in_use: 'Bereits vergeben',
        in_use_by: 'Bereits vergeben an {title}',
        reason_disabled: 'Nicht verfügbar',
        boundary_from: 'Grenze: {source}.',
        boundary_drawn: 'Grenze von dir gezeichnet',
        source_link_short: 'Seite öffnen',
        fact_type: 'Typ',
        fact_country: 'Land',
        fact_size: 'Größe',
        fact_source: 'Quelle',
        boundary_title: 'Grenze',
        boundary_free_same: 'Derselbe Ort steht noch einmal in {list}; diese Grenze ist noch frei.',
        boundary_not_changed: 'Die Grenze wurde nicht geändert: es dauerte zu lange.',
        boundary_free_elsewhere: 'Derselbe Ort steht auch in {list}; diese Grenze ist noch frei.',
        choose_that: 'Diese Grenze wählen',
        boundary_list_in_use: '{list}: schon genutzt von {title}',
        boundary_list_unavailable: '{list}: nicht verfügbar',
        partial_note: 'Diese Grenze umfasst nur die Kernzone von {name}, nicht das ganze Gebiet.',
        proxy_note: 'Dies ist das Gebiet, nach dem {name} benannt ist; die genaue Grenze ist noch nicht verfügbar.',
        draw_note: 'Die Liste hat keine Grenze für {name}. Du zeichnest sie; die Community behält Namen und Angaben aus der Liste.',
        draw_boundary: 'Grenze zeichnen',
        reported_size: 'angegeben {size}',
        pick_hint: 'Wähle ein Gebiet aus den Ergebnissen, um es auf der Karte zu sehen.',
        map: 'Karte',
        satellite: 'Satellit',
        reset_view: 'Ganzes Gebiet zeigen',
        name_hint: 'Aus der Liste übernommen; du kannst ihn ändern.',
        free_instead: 'Selbst zeichnen',
        in_use_error: '{name} wurde gerade für eine andere Community gewählt. Die Ergebnisse sind aktualisiert.',
        sources: {
          unesco: 'UNESCO',
          eea: 'Europäische Umweltagentur (EEA)',
          wdpa: 'Protected Planet (WDPA)',
          osm: 'OpenStreetMap',
          research: 'Forschungsdatensatz',
          national: 'Nationale offene Daten',
          arcgis: 'Veröffentlichte Kartenebene',
          province: 'Naturpflegekarte der Provinz',
          other: 'Andere Quelle'
        }
      }
    },
    owner_register: {
      title: 'Registriere deine Organisation als Gebietseigentümer',
      lead: 'Du kannst eine Community rund um Land starten, das du verwaltest. Vorher prüfen wir, wer du bist.',
      what_happens: 'Was nach der Registrierung passiert',
      step1_title: 'Konto anlegen',
      step1_text: 'Du bekommst sofort deine Eigentümerseite.',
      step2_title: 'Wir verifizieren deine Organisation',
      step2_text: 'Ein Greenmapper-Admin prüft deine Angaben. Deine Eigentümerseite zeigt das Ergebnis.',
      step3_title: 'Communities anlegen',
      step3_text: 'Wähle ein offizielles Gebiet oder zeichne dein eigenes.',
      banner: 'Nach der Registrierung verifiziert ein Greenmapper-Admin deine Organisation. Bis dahin siehst du deine Eigentümerseite, kannst aber noch keine Communities anlegen.',
      stepper_account: 'Dein Konto',
      stepper_organization: 'Deine Organisation',
      your_name: 'Dein Name',
      organization: 'Organisation',
      organization_too_long: 'Höchstens {maxLength} Zeichen',
      organization_required: 'Gib den Namen deiner Organisation ein',
      consent: 'Ich stimme der {link} zu.',
      privacy_statement: 'Datenschutzerklärung für Landschaftsorganisationen',
      consent_required: 'Stimme der Datenschutzerklärung zu, um fortzufahren.',
      submit: 'Eigentümerkonto anlegen',
      already_registered: 'Schon registriert?',
      log_in: 'Anmelden',
      created: 'Dein Eigentümerkonto ist bereit.'
    },
    owner_dashboard: {
      create_community: 'Community anlegen',
      strip_pending: 'Wartet auf Verifizierung.',
      strip_rejected: 'Deine Registrierung wurde nicht genehmigt.',
      strip_verified: 'Verifiziert',
      text_pending: 'Du kannst deine Communities ansehen. Bearbeiten und Anlegen ist möglich, sobald ein Greenmapper-Admin deine Organisation verifiziert hat.',
      text_rejected: 'Du kannst dich weiterhin anmelden und deine Communities ansehen. Änderungen bleiben gesperrt.',
      text_verified: 'Du kannst deine Communities anlegen und verwalten.',
      title_pending: 'Deine Organisation wird geprüft',
      title_rejected: 'Deine Registrierung wurde nicht genehmigt',
      lead_pending: 'Ein Greenmapper-Admin verifiziert {organization}. Bis dahin bleiben deine Communities für Fans online, und du kannst sie hier ansehen.',
      lead_rejected: 'Ein Greenmapper-Admin konnte {organization} nicht verifizieren. Deine Communities bleiben für Fans online, und du kannst sie hier ansehen.',
      feedback_label: 'Nachricht von Greenmapper',
      got_it: 'Verstanden',
      new_badge: 'Neu',
      step_registered: 'Registriert',
      step_registered_text: 'Dein Eigentümerkonto existiert.',
      step_verification_pending: 'Verifizierung, jetzt',
      step_verification_pending_text: 'Du musst nichts tun.',
      step_verification_rejected: 'Verifizierung, nicht genehmigt',
      step_verification_rejected_text: 'Siehe die Nachricht oben.',
      step_manage: 'Communities verwalten',
      step_manage_text: 'Communities anlegen und bearbeiten.',
      your_communities: 'Meine Communities',
      official_area: 'Offizielles Gebiet',
      drawn_area: 'Gezeichnetes Gebiet',
      boundary_drawn: 'Grenze von dir gezeichnet',
      fans: 'keine Fans | 1 Fan | {count} Fans',
      summary_communities: 'keine Communities | 1 Community | {count} Communities',
      community_verified: 'von Greenmapper verifiziert',
      community_status_pending: 'Wartet auf Prüfung',
      community_fans_after_approval: 'Fans werden hinzugefügt, sobald die Community genehmigt ist.',
      community_status_verified: 'Verifiziert',
      community_status_rejected: 'Abgelehnt',
      edit: 'Bearbeiten',
      edit_community: '{title} bearbeiten',
      community_status_changed: 'Geändert · wartet auf Prüfung',
      community_rejected_reason: 'Grund: {comment}',
      community_deleted: 'Deine Community „{title}“ wurde von Greenmapper gelöscht.',
      view_only: 'Nur ansehen',
      no_communities_verified: 'Du hast noch keine Communities. Lege deine erste an.',
      no_communities_waiting: 'Du hast noch keine Communities. Du kannst sie anlegen, sobald du verifiziert bist.'
    },
    community_edit: {
      title: 'Community bearbeiten',
      back: 'Zurück',
      draw_title: 'Grenze ändern',
      change_boundary: 'Grenze ändern',
      official_read_only: 'Offizielle Grenze: kann nicht geändert werden.',
      boundary_not_editable: 'Diese Grenze kann hier nicht geändert werden.',
      boundary_changed: 'Neue Grenze, noch nicht gespeichert',
      rereview_hint: 'Nach dem Speichern prüft Greenmapper die neue Grenze erneut.',
      zone_removed: 'Mit einer neuen Grenze entfällt die Fanzone: Fans zählen dann innerhalb der Grenze.',
      use_boundary: 'Diese Grenze verwenden',
      save: 'Speichern',
      saved: 'Änderungen gespeichert',
      not_found: 'Community nicht gefunden.',
      leave_title: 'Änderungen verwerfen?',
      leave_text: 'Deine Änderungen sind noch nicht gespeichert.',
      leave_draw_text: 'Deine Änderungen an der Grenze gehen verloren. Die Grenze bleibt, wie sie war.',
      leave_keep: 'Weiter bearbeiten',
      leave_confirm: 'Verwerfen'
    },
    admin_home: {
      title: 'Admin',
      text: 'Im Aufbau: Hier entsteht die Home-Seite für Admins.'
    },
    // the admin's e-mail templates and score settings (#341)
    email_templates: {
      title: 'E-Mail-Vorlagen',
      empty: 'Keine E-Mail-Vorlagen gefunden',
      col_key: 'Schlüssel',
      col_description: 'Beschreibung'
    },
    score_settings: {
      title: 'Punkte-Einstellungen',
      empty: 'Keine Punkte-Einstellungen gefunden',
      col_key: 'Schlüssel',
      col_description: 'Beschreibung',
      col_value: 'Punkte'
    },
    admin_fans: {
      title: 'Fans',
      search: 'Name, E-Mail, Tag oder Ort',
      stat_day: 'Neu heute',
      stat_week: 'Neu in 7 Tagen',
      stat_month: 'Neu in einem Monat',
      stat_year: 'Neu in einem Jahr',
      stat_total: 'Alle Fans',
      col_name: 'Name',
      col_email: 'E-Mail',
      col_created: 'Registriert',
      col_age: 'Alter',
      col_gender: 'Geschlecht',
      col_score: 'Punkte',
      col_locale: 'Sprache',
      col_areas: 'Gebiete',
      col_funding: 'Förderung',
      col_tags: 'Tags',
      col_subs: 'Folgt',
      funding_finished: 'Förderung abgeschlossen',
      funding_not_finished: 'Förderung nicht abgeschlossen',
      empty: 'Keine Fans gefunden.',
      areas_title: 'Gebiete',
      no_areas: 'Keine Gebiete gezeichnet.',
      profile_title: 'Profil',
      log_title: 'Aktivitätsprotokoll',
      log_show: 'Anzeigen',
      log_hide: 'Ausblenden',
      log_filter: 'Protokoll filtern',
      log_empty: 'Keine Protokolleinträge.',
      log_none_match: 'Keine Einträge passen zum Filter.',
      log_failed: 'Protokoll konnte nicht geladen werden',
      log_session: 'Sitzung',
      log_geometry: 'Geometrie',
      log_scope: 'Ebene',
      registration_finished: 'Registrierung abgeschlossen',
      details: {
        user_id: 'Benutzer-ID',
        created: 'Erstellt',
        email_verified: 'E-Mail bestätigt',
        place: 'Ort',
        disclaimer: 'Haftungsausschluss akzeptiert',
        updated: 'Profil geändert',
        education: 'Ausbildung',
        city: 'Stadt',
        communities: 'Communities',
        no_communities: 'Folgt keinen Communities',
        gone_communities: '{count} existiert nicht mehr | {count} existieren nicht mehr',
        funding: 'Finanzierungszusage',
        amount: 'Betrag',
        reason: 'Grund',
        yes: 'ja',
        no: 'nein'
      }
    },
    // the admin's communities screen (#341)
    admin_communities: {
      // the row menu's link to the community's area facts (#533)
      area_facts: 'Gebietsfakten',
      title: 'Communities',
      search: 'Name, Eigentümer oder Gebiet',
      col_name: 'Community',
      col_owner: 'Eigentümer',
      col_area: 'Gebiet',
      col_created: 'Erstellt',
      col_status: 'Status',
      col_fanzone: 'Fanzone',
      col_fans: 'Fans',
      col_threads: 'Gespräche',
      col_polls: 'Umfragen',
      col_polis: 'Polis',
      col_meetings: 'Treffen',
      col_pledges: 'Zusagen',
      col_mods: 'Moderatoren',
      empty_waiting: 'Keine Communities warten auf Prüfung.',
      empty_rejected: 'Keine abgelehnten Communities.',
      empty_verified: 'Noch keine bestätigten Communities.',
      empty_all: 'Keine Communities gefunden.',
      more_actions: 'Weitere Aktionen für {title}',
      open: 'Community öffnen',
      edit: 'Bearbeiten',
      pending_done: '{title} wartet wieder',
      reject_title: '{title} ablehnen?',
      facts_title: 'Community',
      description_title: 'Beschreibung',
      no_description: 'Keine Beschreibung.',
      no_moderators: 'keine',
      content: 'Inhalt',
      fan_zone_fans: 'Fans in der Zone',
      fan_zone_after_approval: 'bei Bestätigung hinzugefügt',
      fan_zone_size: 'Fanzone',
      fan_zone_position: 'Stellung',
      fan_zone_start: 'Empfohlen',
      fan_zone_area: 'Gebiet'
    },
    admin_owners: {
      title: 'Gebietseigentümer',
      search: 'Name, E-Mail oder Organisation',
      tab_waiting: 'Wartend',
      tab_rejected: 'Abgelehnt',
      tab_verified: 'Verifiziert',
      tab_all: 'Alle',
      only_with_communities: 'Nur Eigentümer mit Communities',
      only_migrated: 'Wartend seit der Migration ({count})',
      load_failed: 'Eigentümer konnten nicht geladen werden',
      empty_waiting: 'Niemand wartet auf Verifizierung.',
      empty_rejected: 'Keine abgelehnten Eigentümer.',
      empty_verified: 'Noch keine verifizierten Eigentümer.',
      empty_all: 'Keine Eigentümer gefunden.',
      status_pending: 'Wartend',
      status_rejected: 'Abgelehnt',
      status_verified: 'Verifiziert',
      personal_email: 'Private E-Mail-Adresse',
      verify: 'Verifizieren',
      reject: 'Ablehnen',
      more_actions: 'Weitere Aktionen für {name}',
      delete_owner: 'Eigentümer löschen',
      rejected_with: 'Abgelehnt mit:',
      reject_reason: 'Warum lehnst du {name} ab?',
      reject_hint: 'Der Eigentümer sieht das auf seiner Eigentümerseite.',
      reject_delete_everything: 'Stattdessen diesen Eigentümer und alles, was dazugehört, löschen',
      reject_delete_hint: 'Löscht das Konto, die Communities und Fan-Gebiete und entfernt diese Communities aus den Abos der Fans. Die Details bestätigst du im nächsten Schritt.',
      reject_delete_continue: 'Weiter zum Löschen',
      reject_owner: 'Eigentümer ablehnen',
      reject_title: '{name} ablehnen?',
      reject_dialog_text: 'Der Eigentümer kann sich weiterhin anmelden und sieht deine Begründung auf seiner Eigentümerseite. Du kannst später noch verifizieren.',
      col_name: 'Eigentümer',
      col_organization: 'Organisation',
      ago_now: 'jetzt',
      ago_min: '{n} Min.',
      ago_hours: '{n} Std.',
      ago_days: '{n} T.',
      ago_months: '{n} Mon.',
      ago_years: '{n} J.',
      change_status: 'Status ändern',
      set_pending: 'Zurück auf wartend',
      pending_done: '{name} wartet wieder auf Verifizierung',
      undo: 'Rückgängig',
      col_email: 'E-Mail',
      col_status: 'Status',
      show_reason: 'Begründung anzeigen',
      col_registered: 'Registriert',
      col_communities: 'Communities',
      col_actions: 'Aktionen',
      col_area: 'Gebiet',
      col_area_drawn: 'Grenze gezeichnet',
      // who counts as a fan (#96)
      col_fan_zone: 'Fanzone',
      fan_zone_col_area: 'Gebiet',
      fan_zone_col_proposal: 'empfohlen',
      fan_zone_title: 'Wer als Fan zählt',
      fan_zone_none: 'Keine Fanzone: Fans zählen innerhalb der Grenze des Gebiets.',
      fan_zone_size: 'Fanzone: {size}',
      fan_zone_position: 'Stellung: {position}',
      fan_zone_vs_start: '{change} gegenüber empfohlen',
      fan_zone_start: 'Empfohlen: {size}',
      fan_zone_area: 'Gebiet: {size}',
      fan_zone_fans_waiting: 'Genehmigen fügt {count} Fans hinzu',
      fan_zone_fans: 'Fans in der Zone: {count}',
      fan_zone_failed: 'Die Fanzone konnte nicht geladen werden.',
      col_verified: 'Verifiziert',
      delete_title: '{name} löschen?',
      delete_text: 'Das löscht das Eigentümerkonto dauerhaft, und:',
      delete_no_communities: 'keine Communities',
      delete_measures: 'keine Fan-Gebiete | 1 Fan-Gebiet | {count} Fan-Gebiete',
      delete_type_to_confirm: 'Gib {name} ein, um zu bestätigen',
      delete_word: 'LÖSCHEN',
      delete_final: 'Das kann nicht rückgängig gemacht werden.',
      delete_confirm: 'Eigentümer löschen | Eigentümer und 1 Community löschen | Eigentümer und {count} Communities löschen',
      verified_done: '{name} ist verifiziert',
      rejected_done: '{name} ist abgelehnt',
      deleted_done: '{name} ist gelöscht',
      community_verified: 'Community {title} verifiziert',
      community_reject: 'Ablehnen',
      community_reject_title: 'Community ablehnen',
      community_reject_text: 'Die Community funktioniert für die Fans weiter. Der Eigentümer sieht deinen Grund auf seinem Dashboard.',
      community_reject_reason: 'Warum lehnst du {title} ab?',
      community_rejected: 'Abgelehnt',
      community_changed: 'geändert',
      community_changed_was_verified: 'Neue Grenze am {date}; war verifiziert',
      community_changed_was_rejected: 'Neue Grenze am {date}; war abgelehnt',
      community_rejected_done: 'Community {title} abgelehnt',
      community_reject_delete: 'Stattdessen diese Community löschen',
      community_reject_delete_hint: 'Für Fake- oder Test-Communities. Im nächsten Schritt siehst du, was gelöscht wird.',
      community_delete_title: '{title} löschen?',
      community_delete_text: 'Dies löscht die Community endgültig, und:',
      community_delete_fans: 'keine Fans verlieren ihr Abo | 1 Fan verliert das Abo | {count} Fans verlieren ihr Abo',
      community_delete_content: 'keine Beiträge, Umfragen, Treffen oder Zusagen | 1 Beitrag, Umfrage, Treffen oder Zusage | {count} Beiträge, Umfragen, Treffen und Zusagen',
      community_delete_official: 'das offizielle Gebiet {name} wird wieder frei',
      community_delete_confirm: 'Community löschen',
      community_delete_reason: 'Grund für den Eigentümer',
      community_delete_reason_hint: 'Der Eigentümer sieht dies auf seinem Dashboard.',
      community_deleted_done: 'Community {title} ist gelöscht'
    },
    maintenance: {
      title: 'Wartung',
      subtitle: 'Einmalige Datenaufgaben für Superadmins. Jede Ausführung wird auf dem Server protokolliert.',
      environment: {
        dev: 'Entwicklung',
        test: 'Test',
        production: 'Produktion'
      },
      load_failed: 'Wartungsaufgaben konnten nicht geladen werden',
      retry: 'Erneut versuchen',
      empty: 'Es gibt keine Wartungsaufgaben.',
      status: 'Aktueller Stand',
      last_result: 'Ergebnis von {action} ({time})',
      unavailable: 'Im aktuellen Zustand nicht verfügbar',
      buttons: 'Was die Schaltflächen tun',
      run_failed: 'Aufgabe fehlgeschlagen',
      run_done: '{action} abgeschlossen',
      confirm_title: 'Bist du sicher?',
      confirm_message: 'Du führst gleich „{action}“ von „{task}“ in dieser Umgebung aus.',
      confirm_changes: 'Dabei werden Daten geändert.',
      confirm_button: 'Ausführen',
      cancel: 'Abbrechen',
      yes: 'Ja',
      no: 'Nein',
      todo_title: 'Zu tun auf diesem Server',
      todo_none: 'Auf diesem Server ist nichts zu tun.',
      all_apply: 'Alles ausführen',
      all_only_after: 'Alles ausführen repariert und prüft dann nur die Formen.',
      all_confirm: 'Zuerst läuft der Testlauf jedes Schritts. Gelingt er, werden diese Schritte nacheinander ausgeführt, in dieser Reihenfolge:',
      all_confirm_order: 'Schlägt der Testlauf fehl, ändert sich nichts und du siehst warum. Ein Schritt, der danach fehlschlägt, stoppt den Rest; die Schritte davor bleiben erledigt. Das Kürzen auf eine Stichprobe gehört nicht dazu: Das bleibt ein eigener Knopf. Auf Produktion zuerst eine Datenbanksicherung machen.',
      all_result_apply: 'Alles ausführen ({time})',
      'all_result_dry-run': 'Testlauf fehlgeschlagen, nichts geändert ({time})',
      all_no_dry_run: 'Kein Testlauf: Dieser Schritt wird einfach ausgeführt.',
      all_done: 'Alles ausgeführt',
      'all_failed_dry-run': 'Testlauf bei {step} fehlgeschlagen: nichts geändert',
      all_failed_apply: 'Gestoppt: {step} ist fehlgeschlagen',
      lists_title: 'Gebietslisten',
      per_list: 'Eine Liste nach der anderen',
      per_list_hint: 'Probelauf, Import, Entfernen oder Kürzen einer einzelnen Liste. Normalerweise reicht Alle Listen importieren oben.',
      other_tools: 'Weitere Werkzeuge',
      // a test error for Sentry (#320)
      sentry: {
        title: 'Sentry-Testfehler',
        description: 'Löst auf dieser Seite einen echten Fehler aus, wie ein Bug es tun würde. In Sentry sollte er diese Umgebung und dieses Release zeigen, dich als Benutzer (ID und E-Mail) und die Datei und Zeile in src/pages/AdminMaintenancePage.vue.',
        off: 'Sentry ist auf dev aus: der Fehler geht nur in die Browserkonsole und logs/browser.log.',
        button: 'Testfehler auslösen',
        col_release: 'Release',
        col_event: 'Sentry-Ereignis',
        sent: 'Testfehler an Sentry gesendet: Ereignis {id}',
        thrown: 'Testfehler ausgelöst (Sentry ist hier aus)'
      },
      col_list: 'Liste',
      col_version: 'Version für Eigentümer',
      col_bundle: 'Neuestes Bündel',
      col_entries: 'Einträge',
      entries_note: 'Einträge: alles, was in der Liste steht. Die Filter von Finde dein Gebiet zählen weniger: Ein Gebiet, das auch in einer anderen Liste steht, zählt dort einmal, unter einer Liste.',
      col_state: 'Stand',
      state_current: 'Aktuell',
      state_newer: 'Neueres Bündel',
      state_not_imported: 'Nicht importiert',
      state_sample: 'Stichprobe',
      state_no_bundle: 'Kein Bündel',
      details: 'Details',
      tasks: {
        'pledge-points-to-areas': {
          todo: {
            apply: '{points} Zusagen haben einen Punkt als Ort: mach daraus kleine Gebiete.'
          },
          title: 'Zusagepunkte zu Gebieten',
          description: 'Gibt jeder Zusage mit einem einzelnen Punkt als Ort ein kleines rundes Gebiet (50 m) um diesen Punkt, da der Zusage-Assistent nur Gebiete zeichnet. Der Eigentümer kann es neu zeichnen. Vor dem Anwenden auf Produktion eine Datenbanksicherung machen.',
          help: {
            'dry-run': 'Zählt die Zusagen mit einem Punkt. Ändert nichts.',
            apply: 'Macht aus diesen Punkten Gebiete und merkt sie sich, damit Zurücksetzen es rückgängig machen kann.',
            rollback: 'Setzt die Punkte bei den Zusagen zurück, deren Gebiet noch das von Anwenden ist; ein vom Eigentümer neu gezeichnetes Gebiet bleibt.'
          },
          actions: {
            'dry-run': 'Probelauf',
            apply: 'Anwenden',
            rollback: 'Zurücksetzen'
          },
          fields: {
            points: 'Zusagen mit einem Punkt',
            communities: 'Communities mit solchen Zusagen',
            applied: 'Durch Anwenden geändert (zurücksetzbar)',
            changed: 'Zusagen geändert',
            restored: 'Punkte zurückgesetzt',
            redrawn: 'Seitdem neu gezeichnet (bleiben so)',
            unreadable: 'Unlesbare Punkte (bleiben so)',
            rolledBack: 'Zurückgesetzt (keine Aufgabe mehr; Anwenden geht noch)',
            gone: 'Seitdem gelöscht (nichts zurückzusetzen)'
          },
          unavailable: {
            'no-points': 'Keine Zusage hat einen Punkt.',
            'nothing-applied': 'Nichts angewendet, das zurückgesetzt werden kann.'
          }
        },
        'fan-subscriptions-cleanup': {
          todo: {
            apply: '{fans} Fans folgen einer gelöschten Gemeinschaft oder einer Gemeinschaft doppelt: ihre Abonnements bereinigen.'
          },
          title: 'Fan-Abonnements bereinigen',
          description: 'Bereinigt die Abonnements der Fans einmalig: Abonnements von Communities, die es nicht mehr gibt, entfallen, und eine Community, der ein Fan mehrfach folgt, bleibt einmal stehen. Die Punktzahlen der Fans bleiben unverändert. Vor dem Anwenden auf Produktion eine Datenbanksicherung machen.',
          help: {
            'dry-run': 'Zählt, was sich ändern würde. Ändert nichts.',
            apply: 'Bereinigt diese Abonnements. Ein Fan, der zwischen Probelauf und Anwenden etwas abonniert, ist beim nächsten Lauf dran. Auf Produktion zuerst eine Datenbanksicherung machen.'
          },
          actions: {
            'dry-run': 'Probelauf',
            apply: 'Anwenden'
          },
          fields: {
            fans: 'Zu bereinigende Fans',
            fansWithGone: 'Fans, die einer gelöschten Community folgen',
            gone: 'Abonnements gelöschter Communities',
            fansWithDuplicates: 'Fans, die einer Community mehrfach folgen',
            duplicates: 'Doppelte Abonnements',
            changed: 'Bereinigte Fans',
            skipped: 'Übersprungene Fans (inzwischen geändert: erneut ausführen)',
            landsWithoutId: 'Communities ohne ID'
          },
          unavailable: {
            clean: 'Nichts zu bereinigen.',
            'lands-without-id': 'Nicht möglich: {landsWithoutId} Communities haben keine ID, ihre Abonnements sind daher nicht von gelöschten zu unterscheiden.'
          }
        },
        'area-facts': {
          warnings: {
            none: 'Gebietsfakten sind eingeschaltet, aber es gibt noch keine Fakten: Umrisse herunterladen, mit build.py ein Paket bauen und importieren (docs/claude/explain/area-facts.md).',
            missing: 'Communities ohne Gebietsfakten: {n}. Sie kommen mit dem nächsten Paket aus den Umrissen dieser Website (Umrisse herunterladen, build.py, importieren).'
          },
          todo: {
            import: 'Ein neues Paket mit Gebietsfakten wartet: {bundle}. Importiere es.'
          },
          title: 'Gebietsfakten',
          description: 'Die Fakten jeder Community und jedes Orts eines Fans aus offenen Daten (Landbedeckung, Schutzgebiete, GBIF-Nachweise), offline berechnet von docs/claude/polygon-lists/area-facts/build.py aus den hier heruntergeladenen Grenzen und auf der Seite Gebietsfakten einer Community gezeigt. Die Downloads: die Grenzen für den Builder (ein Fan nur als Pseudonym) und der Forschungsexport als CSV oder GeoJSON (Codebuch: docs/claude/explain/area-facts.md).',
          help: {
            'switch-on': 'Schaltet das Experiment ein: die Seite Gebietsfakten, ihren Eintrag im Communities-Menü und die Downloads.',
            'switch-off': 'Schaltet das Experiment aus: Seite, Menüeintrag und Downloads verschwinden; die Fakten bleiben (Entfernen löscht sie).',
            'dry-run': 'Liest das neueste Paket und zählt, was Importieren behalten und ablehnen würde. Ändert nichts.',
            import: 'Ersetzt die Gebietsfakten durch die des neuesten Pakets.',
            remove: 'Entfernt alle Gebietsfakten.',
            'download-outlines': 'Die Grenze jeder Community und jedes Orts eines Fans, für build.py: ein Fan nur als Pseudonym, ohne Namen oder E-Mail.',
            'download-csv': 'Eine Zeile pro Community und Ort eines Fans: die Fakten, die Antworten zum Ort, keine persönlichen Felder.',
            'download-geojson': 'Dieselben Zeilen mit ihren Grenzen.'
          },
          actions: {
            'switch-on': 'Einschalten',
            'switch-off': 'Ausschalten',
            'dry-run': 'Probelauf',
            import: 'Importieren',
            remove: 'Entfernen',
            'download-outlines': 'Grenzen herunterladen',
            'download-csv': 'CSV herunterladen',
            'download-geojson': 'GeoJSON herunterladen'
          },
          fields: {
            on: 'Ein',
            bundle: 'Neuestes Paket',
            imported: 'Importiertes Paket',
            importedAt: 'Importiert am',
            records: 'Fakten',
            refused: 'Abgelehnt',
            withoutFacts: 'Ohne Fakten',
            lands: 'Communities',
            places: 'Orte von Fans',
            file: 'Datei',
            size: 'Größe (Bytes)',
            version: 'Version',
            removed: 'Entfernt'
          },
          unavailable: {
            off: 'Das Experiment ist ausgeschaltet: zuerst einschalten.',
            no_bundle: 'Noch kein Paket in _area-facts/bundles.',
            nothing: 'Noch keine Gebietsfakten importiert.'
          }
        },
        'log-sessions': {
          todo: {
            apply: '{rows} Logzeilen enthalten das Login-Token eines Fans als Sitzung: ersetzen.'
          },
          title: 'Login-Tokens in den Logs',
          description: 'Bis #577 speicherten der Gebiets-Assistent und die Finanzierungsumfrage das Login-Token des Fans als Sitzung jeder Logzeile; damit konnte man sich als dieser Fan anmelden. Ersetzt jede solche Sitzung durch eine zufällige ID; die Zeilen einer Anmeldung bleiben zusammen.',
          help: {
            'dry-run': 'Zählt die Zeilen und Sitzungen. Ändert nichts.',
            apply: 'Ersetzt diese Sitzungen durch zufällige IDs. Nicht rückgängig zu machen, und so gewollt.'
          },
          actions: {
            'dry-run': 'Probelauf',
            apply: 'Anwenden'
          },
          fields: {
            rows: 'Zeilen mit Login-Token',
            sessions: 'Sitzungen (Besuche)'
          },
          unavailable: {
            clean: 'Nichts zu ersetzen.'
          }
        },
        'score-duplicates': {
          todo: {
            apply: '{extra} Punktwerte sind doppelt vorhanden (ein Datenimport): die zusätzlichen Kopien entfernen.'
          },
          title: 'Doppelte Punktwerte',
          description: 'Entfernt die zweite Kopie der Punktwerte (Gebiet zeichnen, Virtuelle Finanzierung, Diskussionsbeitrag, Zusage), die ein Datenimport hinterlassen hat: die Seite Punkte zeigte jeden Wert doppelt, und eine Änderung erreichte nur eine Kopie. Behält die Kopie, die der Testserver hat, sonst die erste. Ein Wert, dessen Kopien sich unterscheiden, bleibt für dich. Jede entfernte Kopie wird aufbewahrt: Zurücksetzen stellt sie wieder her. Alles ausführen führt es nach einem Deploy aus; nach Zurücksetzen wartet es auf Anwenden von Hand.',
          help: {
            'dry-run': 'Zeigt die doppelten Werte und zählt die Kopien, die Anwenden entfernen würde. Ändert nichts.',
            apply: 'Entfernt die zusätzlichen Kopien; pro Wert bleibt eine.',
            rollback: 'Stellt jede Kopie wieder her, die Anwenden entfernt hat.'
          },
          actions: {
            'dry-run': 'Probelauf',
            apply: 'Anwenden',
            rollback: 'Zurücksetzen'
          },
          fields: {
            extra: 'Zusätzliche Kopien',
            keys: 'Doppelte Werte',
            differing: 'Kopien, die sich unterscheiden (bleiben stehen)',
            removed: 'Entfernte Kopien',
            appliedAt: 'Zuletzt angewendet',
            rolledBackAt: 'Zurückgesetzt am',
            changedSince: 'Punktwert seitdem geändert',
            restored: 'Wiederhergestellte Kopien'
          },
          unavailable: {
            clean: 'Nichts doppelt.',
            'nothing-applied': 'Nichts angewendet, das zurückgesetzt werden kann.',
            'changed-since': 'Nicht mehr möglich: ein Punktwert wurde seit Anwenden geändert, und die alte Kopie würde ihn mit einem anderen Wert verdoppeln.'
          },
          warnings: {
            'values-differ': 'Die Kopien von {keys} haben verschiedene Werte: die Punktzahl hängt davon ab, welche Kopie die Datenbank liefert. Die falsche Kopie von Hand entfernen.'
          }
        },
        'owner-status-migration': {
          todo: {
            apply: 'Die Migration des Eigentümerstatus wurde auf diesem Server noch nicht angewendet.'
          },
          title: 'Migration des Eigentümerstatus',
          description: 'Gibt jedem bestehenden Eigentümer ohne Status den Status wartend, auch Eigentümern, die Admin sind. Ein Admin verifiziert danach jeden Eigentümer von Hand auf der Seite Gebietseigentümer. Vor dem Anwenden auf Produktion ein Datenbank-Backup machen.',
          help: {
            'dry-run': 'Zählt die Eigentümer ohne Status; alle würden wartend. Ändert nichts. Die Zahl wird gemerkt und mit dem verglichen, was Anwenden ändert.',
            apply: 'Setzt diese Eigentümer einmalig auf wartend. Danach: Gebietseigentümer öffnen, „Wartend seit der Migration“ ankreuzen und die echten Eigentümer verifizieren, die mit Communities und Fans zuerst. Bis dahin können sie ihre Communities nicht verwalten. Auf Produktion vorher ein Datenbank-Backup machen.',
            rollback: 'Entfernt den Status wieder bei genau den Eigentümern, die Anwenden geändert hat. Nur möglich, solange kein Admin einen von ihnen verifiziert oder abgelehnt hat: danach schaltet es sich selbst ab.'
          },
          actions: {
            'dry-run': 'Probelauf',
            apply: 'Anwenden',
            rollback: 'Zurücksetzen'
          },
          fields: {
            applied: 'Angewendet',
            appliedAt: 'Angewendet am',
            owners: 'Eigentümer',
            pending: 'Auf wartend',
            dryRunOwners: 'Eigentümer beim Probelauf davor',
            adminDecisions: 'Seitdem von einem Admin entschieden',
            rolledBack: 'Zurückgesetzte Eigentümer'
          },
          unavailable: {
            'admin-decided': 'Nicht mehr möglich: Ein Admin hat bereits über {adminDecisions} der migrierten Eigentümer entschieden, und Zurücksetzen würde das rückgängig machen.'
          },
          warnings: {
            'count-differs': 'Anwenden hat {applied} Eigentümer geändert, der Probelauf davor zählte aber {dryRun}. Auf der Seite Gebietseigentümer prüfen, ob die richtigen Eigentümer wartend sind.'
          }
        },
        'geometry-check': {
          todo: {
            never_run: 'Die Geometrieprüfung ist auf diesem Server noch nie gelaufen.'
          },
          title: 'Formprüfung',
          description: 'Prüft jeden Ort eines Fans, jede Community-Grenze und jeden Wohnort auf Fehler: fehlende oder kaputte Formen, sich kreuzende Linien, Formen am falschen Ort (bei 0,0, Breite und Länge vertauscht, weit vom Wohnort), viel zu klein oder zu groß, unmögliche Ebenen, doppelte und verwaiste Formen. Liest nur: ändert nichts. Läuft im Hintergrund; die Zahlen stehen hier, wenn sie fertig ist.',
          help: {
            run: 'Prüft die Datenbank dieser Umgebung.',
            'run-copy': 'Prüft die dafür eingerichtete Kopie einer Datenbank (settings: geometryCheck.copyUrl), z. B. eine Kopie der Produktion auf dev.'
          },
          actions: {
            run: 'Prüfen',
            'run-copy': 'Kopie prüfen'
          },
          fields: {
            lastRun: 'Letzte Prüfung',
            state: 'Stand',
            source: 'Datenbank',
            startedAt: 'Gestartet',
            finishedAt: 'Fertig',
            checked: 'Geprüft',
            defects: 'Fehler',
            error: 'Fehler',
            started: 'Gestartete Prüfung'
          },
          unavailable: {
            running: 'Eine Prüfung läuft bereits.',
            'no-copy': 'Keine Kopie einer Datenbank eingerichtet.'
          }
        },
        'geometry-fix': {
          title: 'Formen reparieren',
          description: 'Repariert die Orte der Fans wie in Issue #76 beschlossen: Formen mit sich kreuzenden Linien werden entwirrt, Doppelklickpunkte entfernt, Formen über den Kartenrand zurückgeschoben oder abgeschnitten, Orte bei 0,0 zum Wohnort des Fans verschoben, Kopien und Orte gelöschter Nutzer gelöscht, unmögliche Ebenen korrigiert, und ein Fan mit abgeschlossener Registrierung bekommt auf jeder Ebene einen Ort (fehlende werden um den Wohnort erzeugt und als erzeugt markiert). Die alte Version jedes geänderten Ortes wird aufbewahrt: Zurücksetzen stellt alles wieder her.',
          help: {
            'dry-run': 'Zählt, was jede Reparatur in dieser Datenbank ändern würde. Ändert nichts.',
            apply: 'Führt alle Reparaturen auf einmal in dieser Datenbank aus. Auf der Produktion zuerst eine Sicherung der Datenbank machen.',
            rollback: 'Stellt alles wieder her, was das letzte Ausführen geändert hat, aus den aufbewahrten alten Versionen.',
            'dry-run-copy': 'Probelauf auf der Kopie der Datenbank (settings: geometryCheck.copyUrl).',
            'apply-copy': 'Ausführen auf der Kopie der Datenbank.',
            'rollback-copy': 'Zurücksetzen auf der Kopie der Datenbank.'
          },
          actions: {
            'dry-run': 'Probelauf',
            apply: 'Ausführen',
            rollback: 'Zurücksetzen',
            'dry-run-copy': 'Probelauf (Kopie)',
            'apply-copy': 'Ausführen (Kopie)',
            'rollback-copy': 'Zurücksetzen (Kopie)'
          },
          fields: {
            lastRun: 'Zuletzt ausgeführt',
            lastRunCopy: 'Zuletzt ausgeführt auf der Kopie',
            run: 'Durchlauf',
            changes: 'Änderungen',
            left: 'Nicht zu beheben'
          },
          unavailable: {
            'no-copy': 'Keine Kopie einer Datenbank eingerichtet.',
            'nothing-applied': 'Nichts ausgeführt, das zurückgesetzt werden kann.'
          }
        },
        'polygon-lists': {
          title: 'Alle Gebietslisten',
          description: 'Importiert jede Liste mit einem neueren Bündel in einem Durchgang und wendet danach einmal die Gebietsgruppen an.',
          help: {
            'import-all': 'Importiert das neueste Bündel jeder Liste, die ein neueres hat als das, aus dem Eigentümer wählen (oder die nie importiert wurde), eine nach der anderen, und wendet danach einmal die Gebietsgruppen an. Aktuelle Listen werden übersprungen. Große Listen (WDPA) dauern viele Minuten.',
            'prune-all': 'Nur auf dem Testserver. Kürzt jede vollständige Liste auf ihre Stichprobe von etwa 100 Gebieten (jedes Mal dieselben); Gebiete mit einer Gemeinschaft bleiben.'
          },
          actions: {
            'import-all': 'Alle Listen importieren',
            'prune-all': 'Alle Listen auf Stichproben kürzen'
          },
          fields: {
            lists: 'Listen',
            active: 'Listen zur Auswahl für Eigentümer',
            withBundle: 'Listen mit einem Bündel',
            toPrune: 'Vollständige Listen zum Kürzen',
            toImport: 'Neuere Bündel zum Importieren',
            samples: 'Listen, die Stichproben sind',
            imported: 'Importiert',
            pruned: 'Auf Stichprobe gekürzt',
            groups: 'Gebietsgruppen',
            groupsFile: 'Datei der Gebietsgruppen'
          },
          unavailable: {
            all_current: 'Jede Liste ist aktuell.',
            all_samples: 'Jede Liste ist bereits eine Stichprobe.',
            no_bundles: 'Im Importordner liegen keine Bündel.',
            nothing_imported: 'Es wurde noch keine Liste importiert.',
            small_lists: 'Die vollständigen Listen haben 100 Einträge oder weniger.'
          },
          todo: {
            import: 'Neue Bündel zum Importieren: {lists}.'
          }
        },
        'polygon-list': {
          title: 'Polygonliste: {list}',
          description: 'Importiert diese Polygonliste aus dem neuesten Bündel in ihrem Ordner (<Importordner>/<Liste>/bundles), geprüft gegen die .sha256-Datei. Eine Liste hat eine Version: Importieren lädt die neuen Einträge neben die alten, schaltet die Liste um, wenn alles da ist, und löscht dann die alten. Ein Zurücksetzen gibt es nicht: Lege dafür ein älteres Bündel in den Ordner und importiere es. Gemeinschaften behalten ihre eigene Grenze und Angaben, was auch mit der Liste geschieht.',
          help: {
            'dry-run': 'Liest das neueste Bündel und prüft jeden Eintrag. Zeigt, wie viele Einträge es hat, je Status, und eventuelle Probleme. Ändert nichts.',
            import: 'Importiert das neueste Bündel und macht es zur Version, aus der Eigentümer wählen, anstelle der bisherigen. Wird abgelehnt, wenn ein Eintrag ein Problem hat (siehe Probelauf); dann ändert sich nichts.',
            remove: 'Nimmt die Liste den Eigentümern weg und löscht alle ihre Einträge. Gemeinschaften darauf behalten ihre Grenze und Angaben.',
            prune: 'Nur auf dem Testserver. Behält etwa 100 unterschiedliche Gebiete dieser Liste (Status, Größen, Anfangsbuchstaben, Länder, mit und ohne Fan-Umriss) und löscht den Rest, damit Test klein und schnell bleibt. Jedes Mal dieselben Gebiete. Gebiete, auf denen eine Gemeinschaft liegt, bleiben immer. Die vollständige Liste zurück: erneut importieren.'
          },
          actions: {
            'dry-run': 'Probelauf',
            import: 'Importieren',
            remove: 'Liste entfernen',
            prune: 'Auf Stichprobe kürzen'
          },
          fields: {
            listKey: 'Liste',
            bundle: 'Neuestes Bündel',
            bundleMB: 'Größe (MB)',
            activeDatasetVersion: 'Version für Eigentümer',
            importedFile: 'Importiertes Bündel',
            importedAt: 'Importiert am',
            entries: 'Einträge in der Datenbank',
            file: 'Datei',
            sha256: 'Prüfsumme',
            datasetVersion: 'Version im Bündel',
            withPolygon: 'Mit Polygon',
            problems: 'Probleme',
            problemExamples: 'Beispiele für Probleme',
            currentVersion: 'Aktuelle Version',
            currentEntries: 'Aktuelle Einträge',
            official: 'Offizielle Grenze',
            accepted: 'Akzeptiert',
            partial: 'Nur Kernzone',
            proxy: 'Ungefähres Gebiet',
            review: 'Zu prüfen (Eigentümer zeichnet)',
            missing: 'Kein Polygon (Eigentümer zeichnet)',
            imported: 'Importiert',
            removedOld: 'Alte Einträge entfernt',
            communities: 'Gemeinschaften auf dieser Liste',
            aliases: 'Kopien in einem anderen Eintrag zusammengeführt (Aliase)',
            movedCommunities: 'Communities von einer Kopie zu ihrem Eintrag verschoben',
            notMovedCommunities: 'Communities auf einer Kopie geblieben (ihr Eintrag hat schon eine)',
            removed: 'Einträge entfernt',
            listRemoved: 'Liste entfernt',
            groupedEntries: 'Gebiete in einer Gruppe',
            groupsFile: 'Datei der Gebietsgruppen',
            groups: 'Gebietsgruppen',
            groupsError: 'Gebietsgruppen nicht angewendet',
            prunedAt: 'Auf Stichprobe gekürzt am',
            prunedFrom: 'Einträge vor dem Kürzen',
            kept: 'Behaltene Einträge',
            sample: 'In der Stichprobe',
            keptInUse: 'Behalten, weil eine Gemeinschaft darauf liegt'
          },
          unavailable: {
            no_bundle: 'Im Ordner dieser Liste liegt kein Bündel.',
            not_imported: 'Die Liste wurde noch nicht importiert.',
            already_pruned: 'Die Liste ist bereits eine Stichprobe. Erneut importieren für die vollständige Liste.',
            small_list: 'Die Liste hat bereits 100 Einträge oder weniger.'
          },
          warnings: {
            groups_stale: 'Die Gebietsgruppen ({file}) wurden für eine andere Version der Liste „{list}“ gemacht: ihre Gebiete sind in keiner Gruppe. Führe groups.py für die Listen in ihrem jetzigen Stand aus und lege die neue Datei in den Ordner _groups.',
            groups_waiting: 'Im Ordner _groups liegt eine neuere Datei der Gebietsgruppen ({file}): sie wird beim nächsten Import einer Liste oder beim Start des Servers angewendet.'
          }
        }
      }
    },
    home: {
      title: 'Heim'
    },
    moderators: {
      title: 'Moderator*innen',
      mod_requests: 'Moderator*innen-Anfragen',
      mods: 'Moderator*innen',
      accept: 'Annehmen',
      deny: 'Ablehnen'
    },
    create_community: {
      title: 'Community erstellen'
    },
    land_owner_register: {
      title: 'Registrierung für Landbesitzer*innen',
      steps: {
        general: {
          nav_title: ' Allgemeine Informationen',
          title: 'Information Landbesitzer*innen',
          task_title: 'Fügen Sie allgemeine Informationen über das Land was Sie besitzen hinzu.',
          email: 'E-Mail'
        },
        draw: {
          nav_title: 'Karte',
          title: 'Gebiet zeichnen',
          task_title: 'Zeichnen Sie Ihr Gebiet ein'
        },
        description: {
          nav_title: 'Beschreibung',
          title: 'Beschreiben Sie ihre Community',
          task_title: 'Fügen Sie einen Titel hinzu, der Ihre Community beschreibt',
          input_title: 'Titel',
          input_title_error: 'Maximal {max} Zeichen',
          input_description: 'Beschreibung',
          task_description: 'Beschreiben Sie, was diese Community so interessant, wertvoll, oder wichtig macht.',
          input_description_error: 'Maximal {max} Zeichen'
        },
        finalize: {
          title: 'Informationen',
          task_title: 'Vielen Dank für das Eingeben dieser Informationen. Wenn Sie auf «Weiter» klicken, schließen wir das Erstellen Ihrer Community ab. Um Themen mit Ihrer Community zu diskutieren, können Sie eine Diskussion eröffnen. Klicken Sie auf die 3 Punkte rechts neben «Diskussionen», um eine neue Diskussion hinzuzufügen.'
        }
      }
    },
    pledge: {
      count: 'Anzahl der Zusagen',
      part1: 'zugesagt von',
      part2: 'Ziel',
      question: 'Würden Sie Mittel aus Ihrem virtuellen Naturbudget für dieses Projekt <b>zusagen</b>?',
      yes: 'Ja, ich möchte Mittel <b>zusagen</b>',
      no: 'Nein, ich möchte <b>keine</b> Mittel zusagen',
      delete_title: 'Zusage löschen',
      delete_text: 'Möchten Sie diese Zusage wirklich löschen?'
    },
    add_pledge: {
      title: 'Geben Sie den Betrag an, den Sie gerne für die Finanzierung dieses Projektes zusagen würden.',
      // Finn's Comment: ??
      reason: 'Bitte erläutern Sie, warum Sie sich für diesen Betrag entschieden haben.',
      reasonNo: 'Bitte erläutern Sie, warum Sie sich gegen eine Zusage von Mitteln für dieses Projekt entschieden haben.',
      confirm_text1: 'Sie möchten derzeit',
      confirm_text2: 'Ihres angegebenen jährlichen Naturbudgets für dieses Projekt bereitstellen. Können Sie diesen Betrag bestätigen?',
      confirm: 'Ich bestätige',
      budget_hint: 'Ihr Naturbudget: € {amount} pro Jahr'
    },
    add_treasure: {
      title_nav: 'Fügen Sie einen Schatz hinzu',
      photos: 'Fotos',
      title: 'Fotos vom Schatz hochladen',
      description: 'Beschreiben Sie, warum Ihnen dieser Ort gefällt. Teilen Sie eine Zeichnung, ein Gedicht, ein Bild oder eine Kurzgeschichte.',
      upload: 'Foto hochladen (.jpg)',
      describe_title: 'Geben Sie Ihrem Schatz einen Titel',
      describe_text: 'Beschreiben Sie mit eigenen Worten, was diesen Schatz für Sie attraktiv, wertvoll oder wichtig macht',
      pin_hint: 'Tippen Sie auf die Karte, wo Ihr Schatz ist.',
      pin_move: 'Ziehen Sie die Nadel oder tippen Sie woanders hin, um sie zu verschieben.',
      pin_outside: 'Dieser Ort liegt außerhalb des Gebiets der Community.',
      show_area: 'Das ganze Gebiet zeigen'
    },
    create_pledge: {
      title_nav: 'Zusage hinzufügen',
      title: 'Beschreiben Sie Ihre Finanzierungszusage mit einem einprägsamen Titel.',
      description: 'Beschreiben Sie Ihre Finanzierungszusage genauer. Geben Sie Hintergrundinformationen, vorgeschlagene Maßnahmen, erwartete Ergebnisse und was Ihre Unterstützer im Gegenzug erhalten.',
      type: 'Art der Zusage',
      fixed: 'Fixiert',
      fixed_desc: 'Zusage einmalig anfragen',
      yearly: 'Jährlich',
      yearly_desc: 'Jährlich wiederholende Zusagen anfragen.',
      '2yearly': '2-Jährlich',
      '2yearly_desc': 'Zusagen alle zwei Jahre anfragen.',
      '3yearly': '3-Jährlich',
      '3yearly_desc': 'Zusagen alle drei Jahre anfragen.',
      '4yearly': '4-Jährlich',
      '4yearly_desc': 'Zusagen alle vier Jahre anfragen.',
      '5yearly': '5-Jährlich',
      '5yearly_desc': 'Zusagen alle fünf Jahre anfragen.',
      goal: 'Legen Sie die Höhe der Finanzierungszusage in Euros fest.',
      goal_error: 'Höchstens € {max}',
      map_title: 'Zeichnen Sie das Gebiet Ihrer Zusage',
      map_outside: 'Ihr Gebiet liegt teilweise außerhalb des Gebiets der Community.'
    },
    edit_pledge: {
      title_nav: 'Finanzierungszusage bearbeiten'
    },
    create_message: {
      sent: 'Die Nachricht wurde gesendet',
      no_communities: 'Keine Communities',
      title_nav: 'Nachricht erstellen',
      steps: {
        community: {
          nav_title: 'Community',
          ask: 'Wählen Sie die <b>Community</b>, an die die Nachricht geht. Sie geht an <b>alle</b> Mitglieder.',
          title: 'NOT USED'
        },
        message: {
          nav_title: 'Nachricht',
          title_ask: 'Geben Sie Ihrer Nachricht einen kurzen, treffenden Titel.',
          body_ask: 'Beschreiben Sie, worum es geht, geben Sie Hintergründe und sagen Sie, was Sie von den Mitgliedern erwarten. Kurz und konkret.'
        },
        finalize: {
          nav_title: 'Abschließen',
          ask: 'So sehen die Mitglieder der Community die Nachricht.'
        }
      }
    },
    create_thread: {
      title_nav: 'Diskussion erstellen',
      title_nav_edit: 'Diskussion bearbeiten',
      title: 'Geben Sie einen Titel an',
      description: 'Verfassen Sie einen ersten Post',
      upload: 'Foto hochladen (.jpg)'
    },
    create_poll: {
      preview: 'Vorschau',
      title_nav: 'Umfrage erstellen',
      title_nav_edit: 'Umfrage bearbeiten',
      title: 'Geben Sie einen Titel an',
      description: 'Verfassen Sie einen ersten Post',
      upload: 'Foto hochladen (.jpg)',
      options: 'Umfrage hinzufügen',
      option: 'Optionen'
    },
    create_polis: {
      id_label: 'Polis-ID',
      title_nav: 'Polis erstellen',
      title_nav_edit: 'Polis bearbeiten',
      title: 'Titel hinzufügen',
      id: 'Polis ID hinzufügen',
      voter_option: 'Nur abonnierte Benutzer*innen können abstimmen.'
    },
    create_meeting: {
      date: 'Datum',
      time: 'Uhrzeit',
      title_nav: 'Treffen erstellen',
      title_nav_edit: 'Treffen bearbeiten',
      title: 'Titel hinzufügen',
      description: 'Beschreibung hinzufügen',
      url: 'Fügen Sie einen externen URL für das Treffen hinzu.',
      dateTime: 'Startzeit und Datum'
    },
    send_invites: {
      title_nav: 'Einladungen senden',
      step: 'Auswählen',
      number: 'Anzahl zufällig eingeladener Mitglieder',
      number_label: 'Anzahl der Einladungen',
      max_error: 'Höchstens {max} Einladungen',
      sent: 'Die E-Mails wurden gesendet'
    },
    meeting: {
      deleted: 'Das Treffen wurde gelöscht',
      delete_title: 'Treffen löschen',
      delete_text: 'Möchten Sie dieses Treffen wirklich löschen?',
      total_subs: 'Anzahl der Abonnent*innen',
      accepted_invites: 'Angenommene Einladungen',
      rejected_invites: 'Abgelehnte Einladungen',
      planned_label: 'geplant am',
      invited_banner: 'Sie wurden zum Meeting eingeladen',
      accepted_banner: 'Sie haben die Einladung angenommen. Wenn Sie ausgewählt werden, erhalten Sie eine E-Mail mit weiteren Einzelheiten zum Treffen.',
      rejected_banner: 'Sie haben die Einladung zum Meeting abgelehnt',
      send_banner: 'Senden Sie den Link zum Treffen an Abonnent*innen, die die Einladung angenommen haben.',
      resend_banner: 'Senden Sie den Link zum Treffen erneut. Achtung, Sie haben den Link bereits gesendet!' // Finn's Comment: This was misspelled in the English version.

    },
    landing: {
      my_portal: 'Mein Xena'
    },
    welcome: {
      // the links between the visitor's pages (#442)
      no_account: 'Noch kein Konto?',
      to_register: 'Konto erstellen',
      have_account: 'Schon ein Konto?',
      to_login: 'Anmelden',
      back_to_login: 'Zurück zur Anmeldung',
      title: 'Willkommen bei Greenmapper',
      introduction: 'Einleitung',
      subtitle_1: 'Natur- und Landschaftsorte markieren',
      paragraph_1: 'In Greenmapper Friends können markieren Sie <b>Natur- oder Landschaftsorte</b> mit <b>Grün und/oder Wasser</b>, der für Sie <b></b>attraktiv, wertvoll oder wichtig</b> sind. Der Ort kann klein oder groß sein, in oder außerhalb einer Stadt oder eines Dorfes. Sie können ihn oft besuchen, selten besuchen oder ihn vor allem aus Geschichten oder Fotos kennen.',
      subtitle_2: 'Warum registrieren?',
      paragraph_2: 'Ihr markierter Ort ist ein Ort, dessen <b>Online-Freund</b> Sie sein können. Deshalb fragen wir einige Angaben ab, um ein Konto zu erstellen. Nur Ihr <b>Anzeigename</b> ist für andere sichtbar.',
      subtitle_3: 'Datenschutzrichtlinie',
      paragraph_3: 'Greenmapper Friends ist eine Initiative der Universität Groningen. Greenmapper Friends speichert Ihre E-Mail-Adresse im Greenmapper Landscape Friend Registry (GLFR). Niemand außer der Greenmapper-Organisation kann auf diese E-Mail zugreifen. Sie können über das GLFR anonym von Grundeigentümer*innen, Landverwalter*innen oder anderen Freund*innen der Region erreicht werden. Diese Dritten haben jedoch keinen direkten Zugriff auf Ihre E-Mail. Wir befolgen die Richtlinien der Europäischen Datenschutz-Grundverordnung zum Datenschutz und zur Speicherung Ihrer personenbezogenen Daten.',
      continue_without_account: 'Ohne Konto fortfahren',
      forgot_password: 'Passwort vergessen?',
      forgot_password_dialog: 'Geben Sie Ihre E-Mail-Adresse ein. Sie erhalten einen Link, um ein neues Passwort zu wählen.'
    },
    introduction: {
      title: 'Einführung',
      text: 'In Greenmapper Friends können Sie <b>Natur- oder Landschaftsorte markieren</b>, die Sie <b>attraktiv, wertvoll oder wichtig</b> finden. Diese Bereiche müssen Orte mit Grün, Wasser oder Natur sein. Dies kann ein Ort in einem Park, an einem See, am Meer, in einem Wald oder auf einer Wiese sein. Es könnte ein Blumenfeld, oder ein Platz zum Vogelbeobachten sein. Es kann ein Ort innerhalb oder außerhalb einer Stadt oder Dorf sein; klein oder groß. Sie können den Ort oft besuchen oder fast nie! Es muss sich nur um einen Ort mit Natur handeln, den Sie schön oder wertvoll finden oder der für Sie von Bedeutung ist.',
      start_btn: 'Umfrage starten'
    },
    register: {
      email_sublabel: 'für andere nicht sichtbar',
      name_sublabel: 'für andere sichtbar',
      name_hint: 'zum Beispiel ein Spitzname oder Vornam',
      address_search_sublabel: '±200 m reichen',
      password_hint: 'mindestens 8 Zeiche',
      map_preview_hint: 'Wählen Sie einen Standort, um ihn auf der Karte zu sehen',
      use_my_location: 'Meinen Standort verwenden',
      geolocate_failed: 'Standort konnte nicht ermittelt werden. Prüfen Sie die Berechtigung oder suchen Sie manuell.',
      location_not_found: 'Kein Standort gefunden. Versuchen Sie Stadt, Adresse oder Postleitzahl.',
      disclaimer_title: 'Disclaimer Greenmapper Friends',
      disclaimer: 'Greenmapper Friends speichert Ihre E-Mail-Adresse im Greenmapper Landscape Friend Registry (GLFR). Niemand außer der Greenmapper-Organisation kann auf diese E-Mail zugreifen. Sie können über das GLFR anonym von Grundeigentümern, Landverwaltern oder anderen Freund*innen der Region erreicht werden. Diese Dritten haben jedoch keinen direkten Zugriff auf Ihre E-Mail. Wir befolgen die Richtlinien der Europäischen Datenschutz-Grundverordnung zum Datenschutz und zur Speicherung Ihrer personenbezogenen Daten. Lesen Sie mehr dazu '
    },
    info_contact: {
      title: 'Über uns',
      contact: 'Kontaktieren',
      disclaimer_title: 'Disclaimer',
      implementation: 'Umsetzung: '
    },
    map: {
      title: 'Gesamtkarte der Community',
      add_btn: 'Markieren Sie ein neues Gebiet',
      share_title: 'Karten-URL teilen',
      share_btn: 'In die Zwischenablage kopieren',
      hint_on_add: 'Fügen Sie einen Punkt zur Karte hinzu um mit dem Zeichnen anzufangen',
      hint_on_end_draw: 'Sie können das Gebiet immernoch bearbeiten',
      zoom_to_area_btn: 'Zum Gebiet zoomen',
      details_btn: 'Details ansehen',
      menu_btn: 'Kartenoptionen',
      layers_btn: 'Karte oder Satellit',
      gps_btn: 'Zu meinem Standort',
      home_btn: 'Zu meinem Zuhause' // share_desc: 'Share'

    },
    timeline: {
      title: 'Zeitachse',
      rating: 'Bewertung',
      rating_subtext: 'Persönliche Bewertung der markierten Gebiete',
      visit_frequency: 'Besuchshäufigkeit',
      visit_frequency_subtext: 'Wie oft Sie dieses Gebiet besuchen',
      activities: 'Aktivitätsart',
      activities_subtext: 'Art der Aktivitäten im Gebiet',
      add_btn: 'Gebiet hinzufügen',
      edit_btn: 'Gebiet bearbeiten',
      delete_btn: 'Gebiet löschen',
      delete_title: 'Gebiet löschen',
      delete_subtitle: 'Sind Sie sicher?'
    },
    add_area_info: {
      title: 'Gebiet hinzufügen',
      add_btn: 'Gebiet hinzufügen'
    },
    my_areas: {
      open_btn: 'In Google Maps zeigen',
      title: 'Meine Gebiete',
      sub_title: 'Alle Naturorte, die ich schön, wertvoll oder wichtig finde',
      created_areas: 'Markierte Gebiete',
      joint_surface: 'Gesamtfläche (km²)',
      and_section_eyebrow: 'Greenmapper-Datenbank Attraktive Natur',
      and_section_title: 'Ihre vier Lieblingsorte nach Maßstab',
      and_complete_badge: 'Alle vier Maßstäbe vollständig',
      free_section_title: 'Selbst hinzugefügte Orte'
    },
    my_communities: {
      open_btn: 'Community öffnen',
      title: 'Meine Communities',
      sub_title: 'Alle Gebiete von Grundstückseigentümer*innen oder Gebietsverwalter*innen, die sich mit meinen Bereichen überschneiden. Hier sind Sie als Freund*in dieser Bereiche erreichbar.',
      delete_btn: 'Abmelden',
      delete_title: 'Abmelden',
      delete_subtitle: 'Sind Sie sicher, dass Sie sich von dieser Community abmelden möchten?',
      befriended_communities: 'Befreundete Communities',
      joint_surface: 'Gesamtfläche (km²)'
    },
    info: {
      text1: 'Greenmapper Friends wurde von Greenmapper entwickelt. Weitere Informationen finden Sie im Greenmapper.',
      text2: 'Wenn Sie Fragen haben oder mit uns Kontakt aufnehmen möchten, senden Sie uns bitte eine E-Mail an:',
      text3: 'Bei Greenmapper Friends versuchen wir, die App und die Daten so genau und fehlerfrei wie möglich zu halten. Sollte die App trotz unserer Bemühungen unvollständige oder ungenaue Informationen enthalten, können wir hierfür keine Verantwortung übernehmen.',
      text4: 'Wir behalten uns das Recht vor, Inhalte ohne vorherige Ankündigung zu ändern, zu entfernen oder hinzuzufügen. Greenmapper Friends übernimmt keine Haftung für die Inhalte von Webseiten, auf die wir per Link verweisen.'
    },
    my_owned_communities: {
      title: 'Meine Communities',
      owned_communities: 'Eigene Communities',
      total_subs: 'Anzahl der Abonnent*innen',
      joint_surface: 'Gesamtfläche (km²)'
    },
    community: {
      report_title: 'Kommentar melden',
      report_subtitle: 'Sind Sie sicher, dass Sie diesen Kommentar an die Moderation melden möchten?',
      report_hint: 'Benennen Sie einen Grund',
      delete_title: 'Inhalt löschen',
      delete_subtitle: 'Sind Sie sicher, dass sie diesen Inhalt löschen möchten?',
      discussions_title: 'Diskussionen',
      discussions_subtitle: 'Offene Diskussionen zu jedem Thema',
      poll_title: 'Umfrage',
      poll_subtitle: 'Einfache Umfrage',
      polis_title: 'Pol.is',
      polis_subtitle: 'Fortschrittliche, interaktive Umfragen mit Stellungnahme zu Aussagen Pol.is',
      pledges_title: 'Zusagen',
      pledges_subtitle: 'Virtuelle Geldzusagen für Biodiversität, Landschaftsqualität, oder nachhaltige Dienste Ausführlicher Online-Workshop oder Treffen mit Freund*innen',
      meetings_title: 'Treffen',
      meetings_subtitle: 'Ausführlicher Online-Workshop oder Treffen mit Freund*innen',
      RMS_dialog_title: 'Moderator*innenstatus anfordern',
      RMS_dialog_text: 'Möchten Sie eine Anfrage senden, um Moderator*in dieser Community zu werden?',
      more_btn: 'Weitere Optionen',
      to_map_btn: 'Auf der Karte zeigen',
      treasures_title: 'Schätze',
      show_report_btn: 'Meldung zeigen',
      join_btn: 'Mitglied werden'
    },
    poll: {
      deleted: 'Die Umfrage wurde gelöscht',
      label: 'Umfrage',
      delete_title: 'Umfrage löschen',
      delete_text: 'Möchten Sie diese Umfrage und ihre Stimmen wirklich löschen?',
      votes: 'Stimmen',
      voted: 'Sie haben abgestimmt'
    },
    polis: {
      deleted: 'Das Polis-Gespräch wurde gelöscht',
      delete_title: 'Polis-Gespräch löschen',
      delete_text: 'Möchten Sie dieses Polis-Gespräch wirklich aus der Community löschen?',
      text: 'Klicken Sie auf "Übersetzung ausschalten", um die Kommentare in Ihrer Originalsprache anzuzeigen. Für jede Aussage können Sie mit „Ich stimme zu“, „Ich stimme nicht zu“ oder „Weiter / Ich bin mir unsicher“ stimmen.',
      text2: 'Sie können Ihre Meinung oder Aussage einreichen, damit andere über Ihre Ideen abstimmen können.'
    },
    account: {
      edit_title: 'Profil bearbeiten',
      saved: 'Profil gespeichert',
      signout_title: 'Ausloggen'
    },
    create_area: {
      title: 'Gebiet erstellen',
      add_title: 'Gebiet hinzufügen',
      home_title: 'Wohnort-Markierung setzen',
      stop_title: 'Registrierung stoppen und später beenden',
      pauze_title: 'Bist du sicher?',
      pauze_text: 'Registrierung unterbrechen und später abschließen',
      map_tips: 'Kartentipps',
      search_place: 'Ort suchen',
      search_not_found: 'Nichts gefunden',
      zoom_smaller: 'Kleiner',
      zoom_bigger: 'Größer',
      area_reset: 'Gebiet zurückgesetzt',
      reset_polygon: 'Polygon zurücksetzen',
      reset_polygon_title: 'Polygon zurücksetzen?',
      reset_polygon_text: 'Damit wird das Polygon wieder so hergestellt, wie es vor dem Bearbeiten aussah.',
      leave_polygon_edit_title: 'Polygonbearbeitungen verlassen?',
      leave_polygon_edit_text: 'Wenn du zurückgehst, wird das Polygon wieder zur Kreisauswahl. Deine Punktänderungen gehen verloren.',
      polygon_guard: {
        cross: 'Linien dürfen sich nicht kreuzen',
        spacing: 'Punkte dürfen nicht zu nah beieinander liegen',
        edge: 'Punkt darf einer anderen Seite nicht zu nah kommen',
        angle: 'Ecke darf nicht so spitz werden',
        area: 'Gebiet darf nicht so klein werden',
        bounds: 'Punkt bleibt im sichtbaren Kartenbereich',
        too_few: 'Gebiet braucht mindestens 3 Punkte',
        not_closed: 'Form ist nicht geschlossen',
        duplicate: 'Zwei Punkte liegen an derselben Stelle',
        range: 'Punkt liegt außerhalb des gültigen Kartenbereichs',
        invalid: 'Diese Form kann nicht gespeichert werden'
      },
      loading: {
        title: 'Karte wird vorbereitet',
        opening: 'Karte wird geöffnet…',
        loading_account: 'Konto wird geladen…',
        loading_areas: 'Ihre Gebiete werden geladen…',
        loading_home: 'Wohnort wird geladen…'
      },
      hints: {
        place_above_area: 'Über Ihrem Gebiet platzieren',
        place_area_here: 'Ort vollständig drin',
        drag_vertex: 'Punkte ziehen für bessere Passform',
        zoom: 'Rein- und rauszoomen',
        at_edge: 'Sie haben den Rand dieses Gebiets erreicht'
      },
      stepper: {
        description: 'Beschreibung',
        rate: 'Bewertung',
        visit_freq: 'Besuchshäufigkeit',
        activities: 'Aktivitätsart ',
        connected: 'Online verbunden'
      },
      steps: {
        level: {
          nav_title: 'Umkreis',
          title: 'Umkreis auswählen',
          task_title: 'Wählen Sie aus, in welchem Umkreis das Gebiet für Sie liegt.',
          options: {
            neighborhood: 'Nachbarschaft',
            living_area: 'Region',
            country: 'Land',
            world: 'Weltweit'
          }
        },
        map: {
          nav_title: 'Karte',
          title: 'Gebiet zeichnen',
          task_title: 'Zeichnen Sie Ihr Gebiet ein.'
        },
        description: {
          nav_title: 'Beschreiben Sie',
          title: 'Beschreibung',
          task_title: 'Wie nennst du dieses Gebiet?',
          input_title: 'Titel',
          input_name: 'Name',
          input_title_error: 'Maximal {max} Zeichen',
          input_description: 'Beschreibung',
          task_description: 'Warum ist dieses Gebiet attraktiv, wertvoll und/oder wichtig?',
          input_description_error: 'Maximal {max} Zeichen'
        },
        rate: {
          nav_title: 'Bewertung',
          title: 'Bewerten Sie Ihr Gebiet',
          task_title: '(Bewertung: 1 = Schlecht, 6 = Mittel, 10 = Perfekt)'
        },
        visit_freq: {
          nav_title: 'Besuchshäufigkeit',
          title: 'Wie oft besuchen Sie Ihr Gebiet?',
          options: {
            daily: 'Täglich',
            weekly: 'Wöchentlich',
            monthly: 'Monatlich',
            few_times_a_year: 'Ein paar Mal pro Jahr',
            yearly: 'Jährlich',
            rarely: 'Manchmal',
            never: 'Nie'
          }
        },
        activities: {
          nav_title: 'Aktivitätsart',
          title: 'Welche Aktivitäten unternehmen Sie in diesem Gebiet?'
        },
        priority: {
          nav_title: 'Priorität',
          title: 'Dieser Ort muss:',
          options: {
            maintained: 'So beibehalten werden',
            strengthened: 'Verbessert werden'
          }
        },
        relationship: {
          nav_title: 'Verbindung',
          title: 'Was ist Ihre Verbindung mit diesem Lieblingsnaturgebiet?',
          options: {
            tourist: 'Tourist',
            inhabitant: 'Anwohner*in',
            work: 'Arbeitsbezogen'
          }
        },

        /*
                        finished: {
                            '1_title': 'Vielen Dank! Ihr erster Ort ist nun auf der Karte eingetragen',
                            '1_text': 'Schon dieser erste Beitrag hilft besser zu verstehen, welche Naturorte Menschen schätzen. Sie können jetzt einen weiteren Ort hinzufügen oder später zurückkehren (über die Schaltfläche oben rechts)',
                            '2_title': 'Sehr gut — Ihre persönliche Karte nimmt langsam Form an',
                            '2_text': 'Jeder hinzugefügte Ort hilft sichtbar zu machen, was Schutz verdient. Sie können jetzt einen weiteren Ort hinzufügen oder später zurückkehren (über die Schaltfläche oben rechts)',
                            '3_title': 'Vielen Dank! Ihr Beitrag liefert bereits wertvolle Erkenntnisse über Natur und Landschaften',
                            '3_text': 'Noch ein Ort macht Ihre Karte vollständig — Sie können aber auch später fortfahren (über die Schaltfläche oben rechts)',
                            '4_title': 'Großartig — Ihre persönliche Karte ist nun vollständig!',
                            '4_text': 'Ihr Beitrag hilft Forschenden und Verantwortlichen besser zu verstehen, welche Orte Menschen erhalten und schützen möchten. Gleich sehen Sie eine Übersicht Ihrer Orte. Zunächst haben wir noch eine kurze Frage zur möglichen finanziellen Unterstützung Ihrer Gebiete'
                        }
        */
        finished: {
          '1_title': 'Vielen Dank! Ihr erster Ort ist nun auf der Karte eingetragen',
          '1_text': 'Schon dieser erste Beitrag hilft besser zu verstehen, welche Naturorte Menschen schätzen.',
          '2_title': 'Sehr gut — Ihre persönliche Karte nimmt langsam Form an',
          '2_text': 'Jeder hinzugefügte Ort hilft sichtbar zu machen, was Schutz verdient.',
          '3_title': 'Vielen Dank! Ihr Beitrag liefert bereits wertvolle Erkenntnisse über Natur und Landschaften',
          '3_text': 'Noch ein Ort macht Ihre Karte vollständig.',
          '4_title': 'Großartig — Ihre persönliche Karte ist nun vollständig!',
          '4_text': 'Ihr Beitrag hilft Forschenden und Verantwortlichen besser zu verstehen, welche Orte Menschen erhalten und schützen möchten. Gleich sehen Sie eine Übersicht Ihrer Orte. Zunächst haben wir noch eine kurze Frage zur möglichen finanziellen Unterstützung Ihrer Gebiete'
        }
      },
      _edit: {
        title: 'Gebiet aktualisieren'
      },
      welcome: {
        title: 'Gebiete zeichnen und Fragen beantworten',
        subtitle: 'Markieren Sie vier Naturorte in verschiedenen Maßstäben und erzählen Sie, warum sie Ihnen wichtig sind.',
        sheet_text: 'Sehen Sie sich die Übersicht unten an. Drücken Sie Weiter, um Ihr erstes Nachbarschaftsgebiet zu zeichnen.',
        how_it_works_title: 'Was Sie auf jeder Ebene tun',
        step_draw: 'Markieren Sie ein Gebiet auf der Karte',
        step_questions: 'Fragen zu Ihrem Ort beantworten',
        step_next_level: 'Für 4 Maßstäbe wiederholen',
        journey_title: 'Vier Maßstäbe, vier Orte',
        video_caption: 'Kurze Anleitung zum Zeichnen eines Gebiets'
      },
      welcome_v3: {
        greeting: 'Willkommen bei Greenmapper Friends',
        title: 'Markieren Sie Ihren Naturort',
        intro: 'Markieren Sie Orte mit Grün, Wasser oder Landschaft, die Sie attraktiv, wertvoll oder wichtig finden.',
        levels_title: 'Vier Maßstäbe',
        levels_intro: 'Wählen Sie auf jeder Ebene einen Ort.',
        checklist_title: 'Was Sie auf jeder Ebene tun',
        step_draw: 'Zeichnen Sie den Ort als Gebiet auf der Karte.',
        step_adjust: 'Passen Sie die Form an und bestätigen Sie das Gebiet.',
        step_questions: 'Beantworten Sie einige Fragen dazu, warum Ihnen dieser Ort wichtig ist.',
        step_repeat: 'Wiederholen Sie diese Schritte für die nächste Maßstabsebene.',
        repeat_hint: 'Sie beginnen in Ihrer Nachbarschaft. Nach den Fragen folgen Region, Land und Welt.',
        start_btn: 'Mit Nachbarschaft starten'
      },
      welcome_v4: {
        title: 'Markieren Sie Ihren Naturort',
        title_next: 'Nächster Ort: {level}',
        intro: 'Markieren Sie Orte mit Grün, Wasser oder Landschaft, die Sie attraktiv, wertvoll oder wichtig finden.',
        intro_next: 'Weiter mit {level}. Markieren Sie einen Ort mit Grün, Wasser oder Landschaft, der Sie attraktiv, wertvoll oder wichtig finden.',
        checklist_title: 'Was Sie auf jeder Ebene tun',
        start_badge: 'Start',
        now_badge: 'Jetzt',
        done_badge: 'Fertig',
        progress: 'Ort {current} von 4',
        start_btn: 'Mit {level} starten',
        continue_btn: 'Weiter mit {level}'
      }
    },
    edit_area: {
      title: 'Gebiet aktualisieren'
    },
    funding: {
      not_eligible: 'Leider können Sie nicht an der Finanzierungsumfrage teilnehmen: Sie fragt nach mindestens zwei eigenen Gebieten.',
      title: 'Virtuelle Natur & Community Mittel',
      // the wizard's bar (the whole name was cut off, the user's review of #493)
      title_nav: 'Naturfonds',
      nav_intro: 'Einleitung',
      nav_amount: 'Höhe',
      nav_locations: 'Orte',
      nav_objectives: 'Ziele',
      nav_finalize: 'Abschließen',
      intro1: 'Hallo!',
      intro2: 'Vielen Dank für Ihre Teilnahme am Greenmapper-Experiment zur Naturfinanzierung.',
      intro3: 'In diesem Abschnitt nutzen Sie den <b>Virtuellen Natur- und Gemeinschaftsfonds</b>. Sie zeigen, wie Sie ein <b>hypothetisches</b> jährliches Naturbudget verteilen würden — <b>ohne tatsächlich zu bezahlen</b>. Zusammen mit anderen Teilnehmenden hilft das Verantwortlichen und politischen Entscheidungsträgern zu verstehen, was Menschen wichtig finden.',
      intro4: '<h6>So funktioniert es in 3 Schritten:</h6>',
      step1: 'Gesamtbudget pro Jahr bestätigen',
      step2: 'Auf Ihre 4 Gebiete verteilen',
      step3: 'Pro Gebiet auf Ziele verteilen: Biodiversität, Landschaft, nachhaltiges Wirtschaften, Kultur, Sonstiges',
      caption: 'Stamm = Gebiet • Äste = Ziele • Äpfel = Beispiel-Projekte.',
      intro5: '<b>Praktisch</b>: 5–8 Min • anonym • keine richtigen/falschen Antworten.',
      intro6: 'Als Dank <b>spenden wir 5 € für die Natur auf Texel,</b> obald Sie diesen Abschnitt abgeschlossen haben.',
      amount1: 'Virtueller Finanzierungsbetrag',
      amount2: 'Wie viel würden Sie – wenn Sie es könnten – jährlich für Ihre Lieblingsnaturgebiete ausgeben? Dieser Betrag ist fiktiv, aber versuchen Sie, eine realistische Wahl zu treffen.',
      amount3: 'Geben Sie unten Ihr (virtuelles) jährliches Naturschutzbudget ein.',
      amount4: 'Erläutern Sie kurz, warum Sie diesen Betrag gewählt haben. Was ist Ihnen, zum Beispiel, besonders wichtig zu unterstützen? Wie haben Sie diesen Betrag ermittelt?',
      amount5: 'Jahresbudget',
      max: 'Maximum Betrag 5000 euro',
      min: 'Minimum Betrag 1 euro',
      locations1: 'Weisen Sie Ihren Lieblingsnaturgebieten ein Budget zu',
      locations2: 'Geben Sie an, wie Sie Ihr gewähltes (virtuelles) Budget auf die virtuellen Natur- und Gemeinschaftsfonds Ihrer bevorzugten Naturgebiete verteilen würden.',
      locations3: 'Können Sie kurz erläutern, warum Sie sich für diese Aufteilung entschieden haben?',
      objectives1: 'Budgetverteilung auf die Finanzierungszwecke',
      objectives2: 'Hier sehen Sie Ihre Mittelzuweisung für die virtuellen Natur- und Gemeinschaftsfonds in Ihrem gewählten Gebiet. Sie können dies für Ihre Lieblingsgebiete in Ihrer Nachbarschaft, Ihrer Region, Ihrem Land und weltweit tun. Geben Sie an, wie Sie Ihr Budget auf die vier Ziele verteilen würden:',
      objectives2a: 'Wenn Sie etwas unterstützen möchten, das nicht in eine dieser Kategorien passt, tragen Sie es bitte unten unter „Sonstiges“ ein und weisen Sie der Kategorie einen Teil Ihres Budgets zu.',
      objectives3: 'Könnten Sie kurz erläutern, warum Sie sich für diese Zielverteilung entschieden haben? Warum haben Sie sich für diese Aufteilung entschieden?',
      biodiversity_title: 'Biodiversitätsschutz',
      biodiversity_text: 'Eine reiche Artenvielfalt trägt zum Funktionieren von Ökosystemen bei und ist entscheidend für den Erhalt allen Lebens auf der Erde. Projekte zum Schutz der biologischen Vielfalt zielen darauf ab, die biologische Vielfalt, oft ganz lokal, zu verbessern oder zu erhalten. Solche Projekte können zum Beispiel die Verbesserung der Boden- und Wasserqualität oder die Installation von Nistkästen für Vögel sein.',
      ALC_title: 'Landschaftsqualität und Aussicht',
      ALC_text: 'Ein schönes Landschaftsbild bezieht sich auf die Aussicht und den Genuss einer Landschaft. Ein solches Projekt kann den Schutz oder die Wiederherstellung von Landschaftselementen wie Hecken, die Renaturierung der Landschaft, oder die Schaffung von Wander- oder Radwegen durch die Landschaft umfassen.',
      SUSBUS_title: 'Nachhaltiges Unternehmertum',
      SUSBUS_text: 'Nachhaltige Unternehmen üben ihre Wirtschaftstätigkeit aus, ohne negative Auswirkungen auf ihre (lokale) Umwelt zu verursachen. Projekte, die auf mehr Nachhaltigkeit in der lokalen Wirtschaft abzielen, können den Übergang von einem konventionellen Bauernhof zu einem biologischen oder naturintegrierten Bauernhof beinhalten. Es kann sich auch um den Aufbau eines Netzwerks lokaler Unternehmen und Organisationen handeln, die Abfall und Umweltverschmutzung durch Zusammenarbeit reduzieren.',
      finalize1: '<b>Danke!</b><br> Vielen Dank für deine Teilnahme an dieser Studie zur Naturfinanzierung der Rijksuniversiteit Groningen. Deine Antworten sind für uns sehr wertvoll. Klicke auf <b>Speichern</b>, um deine Antworten zu sichern.',
      finalize1A: '<b>Hurra!</b><br> Du hast 10 € für Naturprojekte auf Texel verdient. Vielen Dank — dein Beitrag hilft uns zu verstehen, wie Menschen die Natur unterstützen möchten.',
      finalize1B: '<b>Was passiert jetzt?</b><br> Du gehst nun zur Greenmapper Friends-Community „Nationalpark Dünen von Texel“ für Teil 3. Dort bewertest du sechs echte Finanzierungsanfragen. Gib für jedes Projekt an, ob du es unterstützt und warum.\n' + 'Dein eigener Beitrag in diesem Experiment ist fiktiv, aber die Spenden von 10 € und 5 € in deinem Namen sind echt.',
      finalize1C: '<b>Zusätzliche Belohnung für Texel</b><br> Wenn du auf alle sechs Anfragen reagierst, spendet Greenmapper weitere 5 €. Jede Reaktion zählt! Nach der Beantwortung aller sechs Anfragen nimmst du automatisch an der Verlosung teil.',
      finalize2: 'Bitte beachten Sie, dass ein Widerruf Ihrer übermittelten Daten ohne Folgen möglich ist. Wenn Sie dies tun möchten oder andere Fragen zur Forschung haben, senden Sie bitte eine E-Mail an j.beverdam@rug.nl.',
      cultural_title: 'Kultur und Gemeinschaftsleben',
      cultural_text: 'Naturgebiete können auch ein kulturelles Erbe oder andere kulturelle Aspekte enthalten. Beispielsweise, wenn historische Gebäude oder Denkmäler vorhanden sind oder bestimmte kulturelle Ereignisse damit verbunden sind. Kulturprojekte können die Organisation von (Musik-)Veranstaltungen, Bildungsausflügen oder die Erhaltung von landschaftlichem Erbe beinhalten.',
      other_title: 'Weiteres',
      other_text: 'Möchten Sie noch etwas in Ihrem Lieblingsnaturgebiet fördern, das oben aber nicht genannt wurde? Dann nennen Sie es doch selbst! Mit diesem Schieberegler können Sie angeben, wie viel von Ihrem Budget Sie dafür zur Verfügung stellen würden. Dies ist nicht verpflichtend, sondern nur falls Ihnen etwas einfällt, das nicht in die vorherigen Förderzielkategorien passt.',
      placeholder: 'Weiteres, namentlich'
    }
  },
  drawer: {
    area_section: 'Entdecken',
    my_section: 'Meine Übersicht',
    other_section: 'Weiteres',
    edit_funding: 'Mein Naturbudget',
    per_year: '/jahr',
    messages: 'Nachrichten'
  },
  mail: {
    to: 'An',
    none: 'Noch keine Nachrichten',
    from: 'Von',
    subject: 'Titel',
    date: 'Datum',
    inbox: 'Posteingang',
    outbox: 'Postausgang',
    compose: 'Verfassen'
  },
  gender: {
    male: 'Männlich',
    female: 'Weiblich',
    other: 'Divers'
  },
  education: {
    1: 'Weniger als Hochschulreife',
    2: 'Hochschulreife',
    3: 'Hochschule ohne Abschluss',
    4: 'Hochschulabschluss',
    5: 'Bachelor',
    6: 'Master',
    7: 'Berufsschulabschluss/ Abgeschlossene Lehre',
    8: 'Doktortitel'
  },
  video: {
    'draw_popup_title_1': 'Nachbarschaft',
    'draw_popup_subtitle_1': 'Bis 2 km von zu Hause',
    'draw_popup_text_1': 'Diese Karte zeigt ein Gebiet von 2 km um Ihren Wohnort. Markieren Sie einen naturnahen Ort innerhalb dieser 2 km, der für Sie attraktiv, wertvoll oder wichtig ist. Wenn Sie keinen Ort innerhalb des 2-km-Umkreises kennen, markieren Sie bitte ein Gebiet, das so nah wie möglich daran liegt.',
    'draw_popup_title_2': 'Region',
    'draw_popup_subtitle_2': 'Bis 20 km von zu Hause',
    'draw_popup_text_2': 'Diese Karte zeigt ein Gebiet von 20 km um Ihren Wohnort. Markieren Sie einen naturnahen Ort innerhalb dieser 20 km, der für Sie attraktiv, wertvoll und wichtig ist.',
    'draw_popup_title_3': 'Land',
    'draw_popup_subtitle_3': 'Ganzes Land',
    'draw_popup_text_3': 'Diese Karte zeigt eine Karte der Niederlande. Markieren Sie naturnahen einen Ort auf dieser Karte, der für Sie attraktiv, wertvoll oder wichtig ist.',
    'draw_popup_title_4': 'Welt',
    'draw_popup_subtitle_4': 'Weltweit',
    'draw_popup_text_4': 'Diese Karte zeigt eine Weltkarte. Markieren Sie einen naturnahen Ort auf dieser Karte, der für Sie attraktiv, wertvoll oder wichtig ist.',
    'draw_popup_video': 'Unten sehen Sie ein kurzes Video (30 Sek.) darüber, wie man ein Gebiet zeichnet.',
    'area_size': 'Gebiet: {width} km breit, {area} km{squared}',
    'step1_helper': 'Verschieben Sie die Karte, bis Ihr attraktiver Ort vollständig im klaren Kreis liegt. Zoomen Sie, bis der Kreis ihn ganz abdeckt.',
    'step2_helper': 'Sieht es gut aus? Weiter — oder ziehen Sie optional die Punkte, damit die Form Ihren Ort besser abdeckt.',
    'clamp_hint_default': 'Dies bleibt innerhalb von {distance}. Bei der nächsten Frage können Sie weiter gehen.',
    'scale_badge_radius': 'Bis {distance} von zu Hause',
    'scale_badge_full': 'Auf der Karte von {name}',
    'level_up_toast': 'Gebiet vergrößert auf {distance}'
  }
};